// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("app-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("l24-bg3t.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body {
  height: auto;
}

html,
#root {
  height: 100%;
}

body {
  height: calc(100% - 75px);
}

.ant-btn {
  width: 100% !important;
}

.agb-container h2 {
  font-size: 18px;
  margin: 20px 0 10px 0;
}

.agb-container p {
  font-size: 14px;
  margin: 20px 0;
  color: #333;
}

.law-container {
  max-width: 800px;
  margin: auto;
}

.law-container h3 {
  margin-top: 20px;
  font-weight: bold;
  font-size: 20px;
}

@media screen and (min-width: 993px) {
  .ant-tabs-nav {
    border-radius: 5px;
    box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);
    margin-bottom: 20px;
    border: 1px solid #cccccc;
    padding: 0 10px;
    margin-top: 20px !important;
  }
}

/*NAVBAR*/
.navbar-leerfahrten {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-mobile-body {
  border-top: 1px solid rgb(241, 242, 246);
}

.navbar-leerfahrten-brand {
  width: 153px !important;
  cursor: pointer;
}
.navbar-leerfahrten-brand svg {
  width: 100%;
  height: 100%;
  border: 1px solid #141414;
  background-color: #fff;
  border-radius: 5px;
}

.autocompleteInput {
  width: 100%;
  height: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #f7f7f7;
}

.autocompleteContainer {
  background: #fff;
  border: 1px solid #eee;
  margin-top: 5px;
  position: absolute;
  padding: 10px 15px;
  border-radius: 5px;
}

.autocompleteItems {
  padding: 2px 0;
  cursor: pointer;
}

.navbar-toggle {
  display: none;
  padding: 0;
  font-size: 1.09375rem;
  line-height: 1;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.4);
  border: none;
}

#navbar-toggle-open svg {
  width: 30px;
  height: 24px;
  padding: 3px;
  color: #ff7474;
}

#navbar-toggle-close svg {
  width: 24px;
  height: 24px;
  padding: 3px;
  color: rgb(255, 163, 163);
  cursor: pointer;
}

.navbar-navigation-mobile {
  z-index: 9999;
  background-color: white;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  display: none;
  transform: translateX(100%);
  transition: all 0.1s;
  overflow: auto;
}

.mobile-button-body .navbar-mobile-col {
  padding: 5px 0;
}

.mobile-button-row {
  width: 100%;
}

.mobile-button-body {
  padding: 15px;
}

.navbar-row-padding {
  padding-left: 15px;
  padding-right: 15px;
}

.navbar-mobile-flex-row {
  border-bottom-width: 1px;
  border-color: rgb(241, 242, 246);
  display: flex;
  flex-direction: row;
  padding-bottom: 15px;
  padding-top: 15px;
  position: relative;
  min-width: 254px;
  border-bottom-style: solid;
}

.navbar-mobile-row-icon {
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: center;
}

.navbar-mobile-row-icon-cnt {
  height: 24px;
  width: 24px;
  margin-right: 10px;
  color: #ff4848;
}

.navbar-mobile-row-icon-cnt svg {
  fill: #ff4848;
}

.navbar-body-text-cnt {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  font-weight: bold;
}

.navbar-body-text-flex {
  display: flex;
  flex-direction: row;
}

.text-span-flex {
  align-items: center;
  display: flex;
  flex-direction: row;
  min-height: 23px;
}

.fEFwefw {
  align-items: center;
  color: rgb(255, 163, 163);
  display: flex;
  flex-direction: column;
  height: 24px;
  justify-content: center;
  margin-left: 10px;
  width: 20px;
}

.settings-subhead {
  font-weight: bold;
  text-transform: uppercase;
  color: #363636;
  font-size: 14px;
  margin-bottom: 15px;
}

.freight-btn-prm {
  border-radius: 5px !important;
  background-color: #ff4848 !important;
  color: #fff !important;
  border: none;
}

.password-tip {
  color: #5c5c5c;
  font-size: 14px;
  text-align: right;
  margin-left: auto;
  width: 100%;
  display: block;
  font-weight: bold;
}

.button-mobile-body-row {
  background: 0 0;
  border: none;
  font-size: inherit;
  margin: 0;
  padding: 0;
  width: 100%;
}

.navbar-mobile-col {
  background-color: #fff;
}

.navbar-mobile-divider {
  align-items: flex-end;
  background-color: #f6f1f1;
  display: flex;
  height: 40px;
  padding: 4px 16px;
}

.profile-info-general-text,
.profile-info-general-text-right {
  font-weight: bold;
  color: #363636;
  display: block;
  width: 100%;
  font-size: 14px;
}

.profile-info-general-text-right {
  color: #ff4848;
  text-align: right;
}

.details-isuser-container {
  max-width: 600px;
  margin: auto;
  margin-top: 100px;
}

.navbar-mobile-divider h2 {
  color: #c3a1a1;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1.2px;
  line-height: 20px;
  margin: 0;
  text-transform: uppercase;
}

.header-no-bg {
  background-color: none;
  position: fixed;
  width: 100%;
  z-index: 5;
  top: 0;
}

.header-no-bg nav {
  border: none !important;
}

.header-no-bg-active nav {
  border: none !important;
}

.header-no-bg-active #navbar-toggle-open svg {
  color: rgb(255, 163, 163);
}
header {
  transition: all 0.1s;
}

.header-no-bg-active {
  background-color: #fff !important;
  position: fixed;
  width: 100%;
  z-index: 5;
  box-shadow: 0px 2px 1px rgba(104, 39, 19, 0.15);
}

.home-trust-container {
  padding: 15px;
}

.home-trust-container img {
  height: 70px;
}

.home-trust-container p {
  margin-bottom: 5px;
  line-height: 14px;
  font-weight: bold;
  color: #141414;
}

.home-trust-section {
  padding: 50px 0;
}

.home-trust-text-container {
  margin-left: 10px;
}

.home-trust-container span {
  margin: 0;
  line-height: 1.2;
  color: #5c5c5c;
}

.navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: #ff4848;
}

.navbar-navigation-mobile .navbar-leerfahrten {
  padding: 20px 0;
}

.navbar-leerfahrten-brand .cls-1 {
  fill: #fff;
}
.navbar-leerfahrten-brand .st0 {
  fill: #141414;
}
.navbar-leerfahrten-brand .st1 {
  fill: #ff4848;
}
.navbar-leerfahrten-brand .cls-2 {
  fill: #141414;
}
.navbar-leerfahrten-brand .cls-3 {
  fill: #ff4848;
}
.navbar-leerfahrten-brand .cls-1 {
  fill: #fff;
}
.navbar-leerfahrten-brand .cls-2 {
  fill: #141414;
}
.navbar-leerfahrten-brand .cls-3 {
  fill: #ff4848;
}

a {
  text-decoration: none;
  color: #141414;
}

a:hover {
  text-decoration: none;
}

header nav {
  height: 75px;
}

.navbar-nav a {
  font-size: 16px;
  font-weight: bold;
}

.navbar-light .navbar-nav .nav-link {
  color: #ff4848;
}

.navbar-light .navbar-nav .nav-link.active {
  color: #ff4848;
}

.navbar-light .navbar-nav .nav-link:hover {
  color: #ff5656;
}

.input-group {
  border-radius: 5px;
  border: 1px solid #fff;
}

.list-control {
  border: 1px solid #fff;
  border-radius: 5px !important;
}

.rating-cnt {
  text-align: center;
  margin: auto;
  height: 100%;
  padding-top: 100px;
  max-width: 600px;
}

.rating-topbar {
  padding: 20px 0;
  justify-content: flex-end;
}

.close-button {
  border: 1px solid #999 !important;
  border-radius: 5px;
  background-color: #fff !important;
  color: #141414 !important;
}

.rating-cnt h3 {
  font-weight: bold;
  font-size: 24px;
  margin: 0;
  color: #363636;
  margin-bottom: 10px;
  margin-top: 20px;
}

.rating-cnt h1 {
  font-weight: bold;
  font-size: 36px;
  margin: 0;
  margin-bottom: 40px;
  color: #363636;
}

.rating-cnt button {
  font-weight: bold;
  padding: 10px 40px;
  width: 100%;
}

.ant-rate {
  font-size: 40px;
}

.form-control {
  border-radius: 5px !important;
}

.list-control:focus {
  border: 1px solid #ff4848;
}

.input-group-text {
  border: 1px solid #fff;
}

#brand-logo {
  width: 140px;
}

.main-default {
  padding: 100px 0 20px 0;
}

.border-container {
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);
  margin-bottom: 20px;
  border: 1px solid #cccccc;
}

.auth-wrapper {
  padding: 40px;
  border-radius: 5px;
  box-shadow: 0px 2px 5px rgba(104, 39, 19, 0.2);
  border: 1px solid #cccccc;
}

.mid-heading {
  font-size: 1.2rem;
  font-weight: bold;
  color: #ff4848;
  margin-bottom: 15px;
}

.toast-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  text-align: center;
  font-weight: bold;
}

.error-toast {
  background-color: rgb(255, 89, 89) !important;
  box-shadow: 2px 0px 5px rgba(104, 39, 19, 0.2);
  color: white;
}

.success-toast {
  background-color: rgb(86, 215, 74) !important;
  box-shadow: 2px 0px 10px rgba(104, 39, 19, 0.2);
  color: white;
}

.ride-details-container {
  margin-bottom: 100px;
}

.toast-container .toast {
  width: 100%;
  max-width: 100%;
  background-color: #fff;
}

.form-label {
  color: #999;
}

.auth-container {
  max-width: 500px;
  margin: auto;
  padding: 50px 0;
}

.auth-wrapper {
  position: relative;
}

.leerfahrten-container {
  margin-top: 75px;
  min-height: 100%;
}

.footer-col-inner {
  margin-bottom: 25px;
}

.listing-container nav {
  height: auto !important;
}

.listing-container nav a {
  width: 25%;
  text-align: center;
  font-size: 1rem;
  color: #ff4848;
}

.listing-container .nav-tabs .nav-link.active {
  color: #ff4848;
}

.listing-container .nav-tabs .nav-link.active,
.nav-tabs .nav-link.active:focus,
.nav-tabs .nav-link.active:hover,
.nav-tabs .nav-link:hover {
  border-bottom: 2px solid #ff4848;
}

.nav-tabs {
  border-bottom: 1px solid #cccccc;
}

.filterPanel {
  padding: 16px 0;
}

.result-inner {
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);
  border-radius: 5px;
  padding: 10px;
  border: 1px solid #cccccc;
  transition: 0.1s;
}

.result-cell {
  margin-bottom: 15px;
}

.desktop-hide {
  display: none;
}

.mobile-back-btn {
  display: none;
}

.contact-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}

.contact-flex-inner {
  display: flex;
  align-items: center;
}

.contact-flex-inner img {
  margin-right: 20px;
}

.contact-flex p {
  margin: 0;
}

.contact-info-text h3 {
  margin-top: 50px;
  font-size: 16px;
  font-weight: bold;
}

#map {
  height: calc(100vh - 75px - 58px - 40px);
  width: 100%;
  position: relative;
  background-color: #eee;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);
  border: 1px solid #cccccc;
  margin-left: 10px;
}

#map img {
  width: 100%;
  height: 100%;
  border-radius: 5px !important;
}

#map .filter {
  height: 100%;
  z-index: 97;
  position: absolute;
  width: 100%;
  top: 0;
}

.allFilters {
  background-color: #fff;
  z-index: 97;
  position: absolute;
  transition: all 0.3s;
  height: 100%;
  width: 90%;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.confirm-email-container {
  display: flex;
  justify-content: center;
  margin: auto;
  margin-top: 150px;
  flex-direction: column;
  max-width: 600px;
}

.confirm-email-container h1 {
  font-size: 24px;
  color: #141414;
  margin-bottom: 10px;
}

.confirm-email-container p {
  font-size: 16px;
  color: #141414;
  margin-bottom: 20px;
  text-align: center;
}

.price-modal {
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: 0;
  bottom: 0;
  border-radius: 5px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.2s;
  transform: translateY(100%);
  z-index: 999999999;
  border-top: 1px solid #ddd;
}
.price-modal form {
  display: none;
}

.price-modal-top,
.price-modal-bottom {
  padding: 20px;
  text-align: center;
}

.price-modal-body h2 {
  font-weight: bold;
  color: #363636;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.price-modal-body input {
  width: 300px;
  text-align: center;
  margin: auto;
  font-weight: bold;
  font-size: 24px;
}

.price-modal-bottom {
  text-align: center;
}

.price-modal-bottom button {
  padding: 10px 40px;
}

.price-modal-body {
  padding: 0 20px;
}

.filter-bg {
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0;
  z-index: 96;
  transition: all 0.2s;
  border-radius: 5px;
}

.end-ride-inner {
  padding: 15px;
}

.end-ride-route-dot {
  height: 10px;
  width: 10px;
  background-color: #ff4848;
  border-radius: 50%;
}

.dashboard-rating-body {
  max-height: 300px;
  overflow-y: scroll;
}

.subRide-finish-container {
  background-color: #47c653;
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  padding: 10px 0;
}

.subRide-finish-container a {
  color: #fff;
}

.end-ride-route-line {
  width: 20px;
  height: 2px;
  background-color: #ff4848;
  transform: rotate(90deg);
  margin: 15px 0;
}

.end-ride-route-text {
  line-height: 1;
  text-align: left;
  margin-left: 5px;
  font-weight: bold;
}

.end-ride-route-empty {
  height: 25px;
}

.end-ride-inner h2 {
  font-weight: bold;
  color: #141414;
  font-size: 1rem;
  text-align: left;
}

.filterPanel button {
  background-color: #fff;
  border: 1px solid #ff4848;
  color: #ff4848;
  border-radius: 5px;
  padding: 5px 20px;
  align-self: center;
}

.app-ad-container {
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom;
  background-size: cover;
  position: relative;
  padding: 50px 0;
}

.body-height {
  height: 1000px;
}

.app-download-img {
  margin-top: 20px;
}

.app-download-img img {
  width: 130px;
  margin-right: 5px;
}

.app-heading {
  font-size: 40px;
  line-height: 48px;
  color: #fff;
  font-weight: bold;
  margin: 0;
  width: 40%;
  margin-bottom: 10px;
}

.app-sub {
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  margin: 0;
}

.app-add-img {
  position: absolute;
  right: 20%;
  bottom: -12%;
  width: 260px;
}

.filterPanel button svg {
  height: 15px;
}

.result-content-container {
  padding: 20px 0;
}

.result-container {
  z-index: 4 !important;
  background-color: #fff;
  padding-right: 20px;
}

.map-container {
  padding-left: 0 !important;
}

.p-name {
  font-weight: bold;
}

.like-section {
  text-align: right;
  font-size: 14px;
}

.sort-text {
  margin: 0;
  color: #ff4848;
  font-weight: bold;
  font-size: 14px;
}

.ant-select-selector {
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.filterPanel button {
  align-self: center;
}

.like-section img {
  height: 18px;
}

.like-section p {
  margin: 0;
  font-weight: bold;
  color: #ff4848;
  margin-top: 5px;
}

.title-icon {
  height: 18px;
  margin-right: 5px;
}

.result-inner-container {
  flex-direction: column;
}

#listing-search-container {
  padding: 10px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  position: fixed;
  background-color: #fff;
  width: 100%;
  height: 64px;
  z-index: 99;
}

.checkbox-custom,
.radio-custom {
  opacity: 0;
  position: absolute;
}

.checkbox-custom,
.checkbox-custom-label,
.radio-custom,
.radio-custom-label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
}

.checkbox-custom-label,
.radio-custom-label {
  position: relative;
  font-size: 18px;
}

.checkbox-custom + .checkbox-custom-label:before,
.radio-custom + .radio-custom-label:before {
  content: "";
  background: #fff;
  border: 2px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  padding: 2px;
  margin-right: 10px;
  text-align: center;
  margin-bottom: 5px;
}

.checkbox-custom:checked + .checkbox-custom-label:before {
  background: #ff4848;
  box-shadow: inset 0px 0px 0px 4px #fff;
  border: 1px solid #ff4848;
}

.radio-custom + .radio-custom-label:before {
  border-radius: 50%;
}

.radio-custom:checked + .radio-custom-label:before {
  background: #ff4848;
  box-shadow: inset 0px 0px 0px 4px #fff;
  border: 1px solid #ff4848;
}

.checkbox-custom:focus + .checkbox-custom-label,
.radio-custom:focus + .radio-custom-label {
  outline: 1px solid #ddd; /* focus style */
}

.text-custom-container {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  transition: all 0.1s;
}

.text-custom-container:focus {
  border: 1px solid #ff4848;
}

.route-adress-col {
  flex: 1 1;
  overflow: hidden;
}

.profile-img img {
  height: 35;
  width: 35px;
  object-fit: cover;
  border-radius: 5px;
}

.profile-img {
  margin-right: 10px;
}

.profile-details {
  line-height: 1;
}

.profile-details {
  flex-direction: column;
}

.profile-link {
  font-size: 14px;
}

.profile-link img {
  height: 13px;
  margin-right: 5px;
}

.route-address {
  line-height: 1;
  overflow: hidden;
  font-size: 14px;
}

.route-address-col {
  width: 100%;
  overflow: hidden;
}

.route-address span {
  font-size: 14px;
  color: #969696;
  line-height: 1;
}

.divider-dot {
  height: 10px;
  width: 10px;
  background-color: #ff4848;
  border-radius: 50%;
}

.divider-waypoint-dot {
  height: 10px;
  width: 10px;
  background-color: #fff;
  border: 1px solid #ff4848;
  border-radius: 50%;
}

.contact-subhead {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0 !important;
}

.bold-text {
  font-weight: bold;
}

.ant-upload-picture-card-wrapper {
  margin-top: 20px;
}

.upload-outside {
  border: 2px solid #47c653;
  padding: 5px;
  border-radius: 100%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.pictures-row {
  margin-bottom: 10px;
}

.pictures-row span {
  font-weight: bold;
  display: block;
  width: 100%;
  margin-bottom: 5px;
}

.pictures-row-flex {
  column-gap: 10px;
  flex-wrap: wrap;
  row-gap: 10px;
  flex-direction: row !important;
}

.custom-link {
  cursor: pointer;
  background-color: #ff4848;
  padding: 2px 10px;
  border-radius: 5px;
  color: #fff !important;
  font-weight: bold;
}

.cursor-pointer {
  cursor: pointer;
}

.custom-link:hover {
  background-color: #ff6262;
}

.custom-link-white {
  cursor: pointer;
  background-color: #fff;
  padding: 2px 10px;
  border-radius: 5px;
  color: #141414 !important;
  font-weight: bold;
  border: 1px solid #eee;
}

.forgot-password-cnt {
  width: 400px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);
  border: 1px solid #cccccc;
  margin: auto;
  margin-top: 120px;
  text-align: center;
}

.forgot-password-cnt h1 {
  font-size: 24px;
  font-weight: bold;
  color: #141414;
  text-align: center;
  margin: 0;
  padding: 10px 0;
}

.forgot-password-cnt p {
  font-size: 18px;
  color: #363636;
  text-align: center;
  margin: 0;
  padding: 10px 20px;
}

.forgot-password-cnt a {
  padding: 10px 20px !important;
  text-align: center !important;
  display: block;
}

.forgot-password-cnt form {
  padding: 0 20px;
}

.forgot-password-cnt input {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 10px 0;
  font-size: 16px;
}

.participants-btn-row {
  column-gap: 5px;
  padding-right: 15px;
}

.participants-btn-row .green-btn {
  background-color: #47c653 !important;
  border: #47c653 !important;
}

.forgot-password-cnt button {
  width: 100%;
  font-weight: bold;
  font-size: 16px;
}

.prm-btn {
  cursor: pointer;
  background-color: #ff4848;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff !important;
  font-weight: bold;
  border: none;
}

.prm-btn:hover {
  background-color: #ff6262;
  border: none;
}

.custom-link-white:hover {
  background-color: #f7f7f7;
}

.noti-inner {
  column-gap: 10px;
}

.noti-img img {
  height: 35px;
}

.noti-text {
  color: #141414;
  font-weight: bold;
  font-size: 14px;
}

.noti-date {
  color: #363636;
  font-size: 14px;
  flex-shrink: 0;
}

.noti-link {
  color: #ff4848;
}

.noti-check {
  background-color: #fafafa;
  border-radius: 5px;
  color: #ddd;
  padding: 5px 10px;
  cursor: pointer;
  border: 1px solid #ddd;
}

.noti-check:hover {
  background-color: #47c653;
  color: #fff;
  border: 1px solid #47c653;
}

.noti-flex {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.upload-done {
  background-color: #47c653;
  border-radius: 100%;
  width: 100%;
  height: 100%;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: auto;
}

.ant-upload.ant-upload-select-picture-card {
  width: 100% !important;
  height: 150px !important;
}

.contact-info img {
  width: 20px;
}

.route-row {
  margin: 2px 0;
}

.divider-line {
  width: 2px;
  height: 10px;
  margin: 0 10px;
  background-color: #ff4848;
  margin-left: 14px;
}

.route-section {
  flex-direction: column;
  justify-content: space-between;
}

.route-divider {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
}

.route-address p {
  margin: 0;
  line-height: 1;
  font-size: 14px;
  color: #141414;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  min-height: 20px;
}

.chats-top-bar-number {
  column-gap: 10px;
}

.chats-top-bar-number p {
  margin: 0;
  margin-right: 5px;
}

.details-button-section {
  background-color: #ff4848;
  color: #fff;
  border-radius: 5px;
  padding: 5px 15px;
  font-size: 14px;
}

.details-button-section:hover {
  color: #fff;
  background-color: #ff4848;
}

.settings-avatar img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  border-radius: 5px;
  object-fit: cover;
}

.listing-container {
  padding-top: 56px;
}

.footer-heading {
  font-size: 16px;
  font-weight: bold;
  color: #363636;
  margin-bottom: 10px;
}

footer ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

footer ul li {
  margin-bottom: 5px;
  color: #4f4f4f;
}

footer ul li a {
  color: #4f4f4f;
}

footer ul li a:hover {
  color: #ff4848;
}

.footer-bottom {
  border-top: 1px solid #cccccc;
  width: 100%;
  padding: 10px 0;
}

.footer-top {
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  margin: 0 0 20px 0;
}

.profile-tab-top {
  padding: 10px;
}

.profile-tab-top-image img {
  height: 40px;
  width: 40px;
  object-fit: cover;
  border-radius: 5px;
}

.profile-tab-top-details {
  flex-direction: column;
  line-height: 1;
  margin-left: 5px;
}

.profile-name {
  font-weight: bold;
  font-size: 14px;
  margin: 0;
  padding: 0;
  margin-right: 5px;
}

.modal-header {
  padding: 10px !important;
}

.chats-top-bar {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
}

.small-heading {
  font-weight: bold;
  font-size: 14px;
  color: #363636;
  padding: 15px 0;
  margin: 0;
}

.divider {
  height: 1px;
  background-color: #cccccc;
  width: 100%;
}

.help-link-img img {
  height: 25px;
}

.help-link-text {
  line-height: 1;
  margin-left: 10px;
}

.help-link-text h3 {
  font-weight: bold;
  margin: 0;
  color: #363636;
  font-size: 14px;
}

.help-link-text p {
  color: #363636;
  margin: 0;
  padding: 0;
}

.help-link {
  padding: 10px 0;
}

.dashboard-container-top {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
}

.container-heading {
  font-weight: bold;
  color: #363636;
  margin: 0;
  font-size: 14px;
}

.dashboard-body-row {
  padding: 10px;
}

.order-date {
  color: #363636;
  font-size: 14px;
}

.order-date-bold {
  font-weight: bold;
  margin-right: 5px;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: #ff5656 !important;
}

.dashboard-body-row:hover {
  background-color: #eeeeee;
}

.dashboard-pagination-container {
  padding: 10px;
  border-top: 1px solid #cccccc;
  text-align: right;
}

.container-heading-icon img {
  height: 20px;
  margin-right: 10px;
}

.dashboard-body-row .btn {
  padding: 0.175rem 0.75rem;
}

.dashboard-pagination-container .btn {
  padding: 0.275rem 0.75rem;
}

.dashboard-container-empty-body {
  padding: 20px 0;
  text-align: center;
  font-weight: bold;
}

.rating-img-container img {
  height: 35px !important;
  width: 35px;
  object-fit: cover;
  border-radius: 5px;
}

.modal-content {
  border-radius: 5px !important;
}

.participants-row {
  flex-basis: 100%;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
}

.participants-row-img {
  height: 45px;
  width: 60px;
  object-fit: cover;
  border-radius: 5px;
}

.freight-row {
  padding: 5px 10px;
}

.freight-btn {
  border-radius: 5px;
  width: 100%;
}

.ant-tabs-ink-bar {
  background: #ff4848 !important;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #ff4848 !important;
}

.ant-tabs-tab:hover {
  color: #ff4848 !important;
}

.rating-text-container p {
  margin: 0;
  padding: 0;
}

.rating-text-container {
  line-height: 1;
  margin-left: 5px;
}

.rating-text-top p {
  margin-right: 5px;
  font-size: 14px;
  font-weight: 600;
}

.rating-text-message {
  padding-top: 2px;
  font-size: 14px;
}

.rating-date-container {
  margin-left: auto;
  text-align: right;
  font-size: 14px;
}

.list-search-control {
  transition: 0.1s;
}

.list-search-control:focus {
  border: 1px solid #ff4848;
  transform: scale(110%) !important;
}

.header-user-img {
  border-radius: 50%;
}

.header-user-img img {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 1px solid #fff;
  object-fit: cover;
}

.header-user-name {
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
}

.header-icon img {
  height: 20px;
  width: 20px;
}

.help-link-img {
  width: 30px;
}

.profile-complete-top {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
}

.profile-complete-body {
  padding: 10px;
}

.profile-complete-item {
  margin-bottom: 5px;
}

.profile-complete-item img {
  height: 15px;
  margin-right: 5px;
}

.profile-complete-text {
  font-weight: bold;
  color: #363636;
}

.leerfahrten-main-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 450px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  position: relative;
}

.leerfahrten-main-background h1 {
  padding-top: 100px;
  font-weight: bold;
  color: #fff;
}

.leerfahrten-main {
  background-color: #fff;
}

.leerfahrten-main-form {
  background-color: white;
  margin-top: -25px;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);
  position: relative;
  z-index: 4;
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
  z-index: 3;
}

.leerfahrten-main-form .ant-input-affix-wrapper,
.leerfahrten-main-form .ant-btn-lg,
.search-main-form .ap-input,
.search-main-form .ap-hint,
.search-main-form .ant-btn-lg {
  border-radius: 5px !important;
}

.search-main-form .ap-input,
.search-main-form .ap-hint {
  border: none;
  background-color: #f1f1f1;
}

.search-main-form .ap-input:focus,
.search-main-form .ap-hint:focus,
.search-main-form .ant-input-affix-wrapper-focused {
  border: 1px solid #ff4848;
}

.leerfahrten-main-form .ant-btn-lg,
.search-main-form .ant-btn-lg {
  background-color: #ff4848;
  color: white;
  border: #ff4848;
  width: 100%;
  height: 100%;
}

.ant-tabs-tab {
  margin: 0;
}

.search-main-form .ant-input-affix-wrapper > input.ant-input {
  background-color: #f1f1f1;
}

.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  padding: 15px 20px;
  font-size: 16px;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
  justify-content: space-between !important;
  width: 100%;
}

.search-main-form .ap-input,
.search-main-form .ap-hint {
  transition: all 0.1s;
}

.search-main-form .ap-input:focus,
.search-main-form .ap-hint:focus {
  transform: scale(101%) !important;
  z-index: 99;
}

.header-no-bg nav {
  background-color: none;
  border-bottom: none;
}

.header-no-bg .navbar-light .navbar-nav .nav-link {
  color: #fff;
}

.leerfahrten-container-no-margin {
  min-height: calc(100vh - 268px);
}

.header-icon svg {
  height: 20px;
  width: 20px;
  color: #ff4848;
  fill: #ff4848;
}

.header-bg {
  background-color: #fff;
  border-bottom: 1px solid #cccccc;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
}

.header-bg #navbar-toggle-open svg {
  color: #ff5656;
}

.create .header-no-bg .navbar-light .navbar-nav .nav-link {
  color: #ff4848;
}

.create .header-no-bg .header-icon svg {
  fill: #ff4848 !important;
}

.leerfahrten-create-input-container {
  border: 1px solid #ddd;
  border-radius: 5px;
}

.leerfahrten-create-btn-cnt {
  position: fixed;
  bottom: 0;
  padding: 40px 0;
  width: 100%;
}

.leerfahrten-create-btn-cnt .btn {
  padding: 10px 40px;
  font-weight: bold;
}

.create-container {
  flex-direction: column;
  max-width: 600px;
  margin: auto;
}

.leerfahrten-create-text-container {
  text-align: center;
  margin: 50px 0;
}

.leerfahrten-create-text-container h1 {
  font-weight: bold;
  font-size: 36px;
  margin: 0;
  color: #363636;
}

.leerfahrten-create-text-container p {
  font-weight: 400;
  font-size: 16px;
  margin: 0;
  color: #999;
}

.input-custom-container {
  border: 1px solid #ddd;
  padding: 10px 10px 10px 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.settings-topbar {
  background-color: #f1f1f1;
  padding: 10px 0;
}

.settings-topbar-header {
  color: #141414;
  font-size: 18px;
  font-weight: bold;
}

.main-mobile-form-home {
  display: none;
}

.setting-top-container {
  background-color: #ff4848;
  color: white;
  padding: 10px 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.setting-top-header {
  font-weight: bold;
  font-size: 14px;
  color: white;
  margin: 0;
}

.settings-container-row {
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 5px;
  display: block;
}

.settings-container-row:hover {
  background-color: #f1f1f1;
}

.settings-container-link {
  font-weight: bold;
  color: #141414;
  font-size: 14px;
}

.settings-container-link svg {
  height: 10px;
}

.settings-container-mobile {
  margin-top: 1.5rem;
}

.leerfahrten-input-container {
  margin-bottom: 10px;
}

.leerfahrten-input-container label {
  font-weight: bold;
  font-size: 14px;
  color: #363636;
  margin-bottom: 5px;
}
.leerfahrten-input-container input {
  width: 100%;
  font-weight: bold;
  font-size: 14px;
  color: #363636;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 5px;
  transition: all 0.1s;
}

.leerfahrten-input-container input:focus {
  transform: scale(102%);
  border: 1px solid #ff4848;
}

.leerfahrten-settings-form {
  padding: 10px;
}

.settings-header {
  font-weight: bold;
  font-size: 16px;
  margin: 0;
  padding: 10px;
}

.leerfahrten-main-form .col-lg-5,
.leerfahrten-main-form .col-md-12,
.leerfahrten-main-form .col-12,
.search-main-form .col-lg-5,
.search-main-form .col-md-12,
.search-main-form .col-12 {
  padding-right: 5px;
  padding-left: 5px;
}

.ant-input-prefix {
  margin-right: 10px !important;
}

.leerfahrten-departure-sidebar {
  z-index: 9999;
  background-color: white;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  display: none;
  left: 0;
  transform: translateX(100%);
  transition: all 0.1s;
  overflow: auto;
}

.leerfahrten-departure-sidebar .ap-dropdown-menu {
  position: fixed !important;
  top: 66px !important;
  box-shadow: none !important;
}

.departure-header-close {
  cursor: pointer;
}

.departure-header-close,
.departure-header-right {
  width: 38px;
  min-width: 38px;
  max-width: 38px;
}

.ap-dataset-places div {
  background-color: #fff !important;
}

.ap-dataset-places div:hover {
  background-color: #fff !important;
}

.departure-sidebar-header {
  flex-direction: row;
  padding: 10px 10px;
  box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.1);
}

.departure-header-input {
  width: 100%;
}

.departure-header-input input {
  border: none !important;
  width: 100% !important;
}

.departure-header-close svg {
  height: 18px;
  width: 18px;
  color: #717fa4;
}

.main-form-input {
  appearance: none;
  font-size: 16px;
}

.main-form-input-mobile {
  border-radius: 5px;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding: 8px 10px;
  cursor: pointer;
}

.main-form-input-mobile svg {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.main-form-input-mobile p {
  margin-bottom: 0;
  font-size: 16px;
}

.main-form-input-mobile span {
  color: #bbb;
  font-size: 16px;
}

#departure-input,
#destination-input {
  font-size: 16px;
}

.search-mobile-container-text {
  flex: 1 1;
  min-width: 0;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

.search-main-form-mobile {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.4);
  z-index: 101;
  transition: all 0.1s;
  transform: translateY(-100%);
}

.mobile-search-form-body {
  margin-top: 20px;
}

.mobile-search-form-body .ant-input-affix-wrapper {
  border: none;
  background-color: #f1f1f1;
  border-radius: 5px;
}

.mobile-search-form-body .ant-input-affix-wrapper input {
  background-color: #f1f1f1;
}

.mobile-search-form-body .ant-btn {
  width: 100%;
  border-radius: 5px;
  color: white;
  background-color: #ff4848;
  border: none;
}

.mobile-search-form-body .row {
  margin: 0;
}

.main-form-mobile-search {
  padding: 20px;
  background-color: #fff;
  box-shadow: 0px 2px 5px rgba(58, 58, 58, 0.4);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.search-mobile-container-close {
  width: 11px;
  height: 20px;
  position: relative;
  margin-right: 24px;
  cursor: pointer;
  color: #ff5656;
}

.search-mobile-container-icon {
  width: 19px;
  height: 20px;
  cursor: pointer;
  color: #ff5656;
  margin-left: 12px;
}
.main-desktop-form-home {
  display: block;
}

.search-mobile-form-container {
  display: none !important;
}

.ride-details-profile-details-body {
  padding: 10px;
  flex-direction: column;
}

.ride-details-profile-details-row {
  padding-bottom: 5px;
}

.ride-details-profile-details-text {
  font-size: 14px;
  color: #141414;
  font-weight: 400;
  margin-right: 5px;
}

.ride-details-profile-details-var {
  color: #ff4848;
  font-weight: bold;
  font-size: 14px;
}

.ride-details-profile-details-icon {
  width: 17px;
  height: auto;
  margin-right: 10px;
  color: #141414;
}

.ride-details-profile-details-contact {
  margin-top: 10px;
  width: 100%;
}

.ride-details-profile-details-contact button {
  border-radius: 5px !important;
  color: white;
  background-color: #ff4848 !important;
  width: 100%;
  border: none;
}

.ride-details-top-container-heading {
  font-weight: bold;
  font-size: 18px;
}

.ride-details-top-container {
  padding: 10px 20px;
}

.ride-details-top-container-date {
  font-size: 14px;
  font-weight: bold;
}
.ride-details-body {
  padding: 10px 20px;
}

.ride-details-body-map {
  width: 100%;
  height: 150px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 10px 0;
}

.ride-details-body-map img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.ride-details-body-route {
  margin: 10px 0;
}

.ride-details-body-waypoints {
  margin: 10px 0;
}

.ride-details-body-description {
  margin: 10px 0;
  line-height: 1.4;
}

.ride-details-body-heading {
  font-weight: bold;
  color: #141414;
  font-size: 15px !important;
}

.top-id {
  font-size: 14px;
  font-weight: 400;
  color: #141414;
}

.top-id-bold {
  font-weight: bold;
  color: #ff4848;
}

.ride-details-body-description span {
  font-size: 14px;
  color: #363636;
  font-weight: 400;
}

.ride-details-body-description p {
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #363636;
  font-weight: 400;
}

.ride-details-body h2 {
  margin-bottom: 5px;
}

.Toastify__toast--success {
  background: #2db931 !important;
}

.Toastify__toast {
  border-radius: 0 !important;
}

.Toastify__toast-container--top-right {
  bottom: 0 !important;
}

.feedback-main-container {
  margin: auto;
  text-align: center;
  padding: 0 10px;
}

.feedback-main-container h2 {
  font-weight: bold;
  color: #363636;
  font-size: 20px;
  margin-bottom: 0;
}

.feedback-main-container textarea {
  margin-top: 20px;
}

.feedback-header {
  text-align: center !important;
  width: 100%;
  font-size: 24px;
  font-weight: bold;
  color: #363636;
}

.waypoints-col {
  background-color: #ff4848;
  color: #fff;
  border-radius: 5px;
  padding: 2px 20px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.ride-details-mobile-top {
  padding: 10px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  position: fixed;
  background-color: #fff;
  width: 100%;
  display: none;
  z-index: 99;
}

.ride-details-body-map-mobile {
  display: none;
  height: 220px;
  width: 100%;
}

.leerfahrten-user-rides-container {
  max-width: 600px;
  margin: auto;
}

.leerfahrten-user-rides-container h1 {
  font-weight: bold;
  font-size: 30px;
  margin: 10px 0;
  color: #363636;
  text-align: left;
}

.footer-btn {
  border: none !important;
  background-color: white !important;
  background: white !important;
  padding: 10px 0;
}

.footer-to-top {
  margin-left: auto;
  display: flex;
}

.leerfahrten-user-rides-container h2 {
  font-weight: bold;
  font-size: 20px;
  margin: 20px 0 10px 0;
  color: #363636;
  text-align: left;
}

.ride-details-body-map-mobile img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.ride-details-mobile-heading {
  display: none !important;
}

.ride-details-mobile-contact-container {
  display: none !important;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 25px 0;
  background-color: #fff;
  z-index: 99;
  box-shadow: 0px -2px 5px rgba(104, 39, 19, 0.2);
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.ride-details-mobile-contact-container .ride-details-profile-details-contact {
  margin-top: 0;
}

.price-header {
  font-weight: bold;
  font-size: 18px;
  color: #141414;
}

.payment-col {
  width: 45px;
  margin-right: 10px;
  margin-top: 10px;
}

.mwst {
  font-weight: 400;
  font-size: 16px;
}

.ride-details-footer {
  display: block;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 20px 0;
  background-color: #fff;
  z-index: 99;
}

.dashboard-ride-details-btn,
.dashboard-ride-details-btn a {
  color: white !important;
  font-size: 14px;
}

.dashboard-ride-details-btn:hover {
  background-color: #ff4848;
  border-color: #ff4848;
}

.ride-details-footer-logo {
  width: 120px !important;
  cursor: pointer;
}

.ride-details-footer-logo svg {
  height: 100%;
}

.ride-details-footer-links a {
  margin-left: 10px;
  font-weight: bold;
  transition: all 0s;
}

.mobile-margin-container {
  margin-bottom: 50px;
}

.ride-details-footer-links a:hover {
  color: #ff4848;
}

/* CHAT */
.chats-head {
  border-bottom: 1px solid #ddd;
  padding: 10px;
}

.chats-body {
  overflow-y: scroll;
  max-height: 200px;
}

.chats-inner-row {
  border-bottom: 1px solid #ddd;
  padding: 10px;
}

.chats-pic img {
  height: 35px;
}

.chats-message {
  margin-left: 10px;
}

.chats-message p {
  margin: 0;
}

.chats-message-name {
  font-weight: bold;
  font-size: 12px;
  color: #363636;
}

.chats-message-text {
  font-size: 12px;
  color: #363636;
}

.chats-info {
  margin-left: auto;
  margin-right: 5px;
}

.chats-info span {
  font-size: 10px;
  background-color: #47c653;
  padding: 0 5px;
  color: white;
}

.chats-icon img {
  height: 13px;
}

.chats-icon span {
  font-size: 12px;
  font-weight: bold;
  color: #363636;
  display: block;
}

.dashboard-chats-container {
  border: 1px solid #ddd;
}

.chat-side-container,
.chat-main-container {
  border: 1px solid #ddd;
}

.chat-main-container {
  overflow-y: hidden;
}

.chat-side-top-bar,
.chat-main-top-bar {
  padding: 10px 10px;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  justify-content: space-between;
}

.chat-side-top-ntf {
  background-color: #ff4848;
  color: white;
  padding: 2px 10px;
  font-weight: bold;
  font-size: 12px;
}

.chat-side-top-bar {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.chat-side-top-bar p {
  margin: 0;
  margin-left: 10px;
  font-weight: bold;
  color: #363636;
}

.chat-side-inner-container {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.chat-side-inner-container:hover {
  background-color: #f0f0f0;
}

.chat-side-pic {
  position: relative;
  margin-right: 10px;
}

.chat-side-pic img {
  height: 35px;
  width: 35px;
  border-radius: 3px;
  object-fit: cover;
}

.chat-side-text-name {
  font-weight: bold;
  font-size: 14px;
  margin: 0;
  color: #363636;
  display: block;
}

.chat-side-text-text {
  color: #555;
}

.chat-side-text {
  line-height: 1.2;
  margin-right: 10px;
}

.chat-side-text-name p {
  margin: 0;
}

.chat-side-ntf {
  margin-left: auto;
  line-height: 1.2;
}

.chat-side-ntf-days {
  font-size: 14px;
  display: block;
  text-align: right;
  margin-bottom: 5px;
  color: #363636;
}

.chat-side-ntf-ntf {
  padding: 0px 5px;
  color: white;
  background-color: #47c653;
  font-size: 10px;
  margin-right: 5px;
}

.chat-side-ntf-img {
  height: 12px;
}

.chat-inner-wrapper {
  height: 60vh;
  overflow-y: scroll;
}

.chat-settings {
  margin-left: 10px;
  cursor: pointer;
  height: 100%;
  padding: 5px 0;
}

.chat-settings div {
  border-radius: 50%;
  height: 6px;
  width: 6px;
  background-color: #ddd;
  margin: 0 1px;
}

.chat-main-profile-info {
  background-color: #f0f0f0;
  padding: 10px;
  vertical-align: middle;
  height: 55px;
}

.chat-main-info-profile-link img {
  height: 14px;
  margin-right: 5px;
}

.chat-main-inner-container {
  height: calc(60vh - 55px);
  position: relative;
  display: flex;
  flex-direction: column;
}

.chat-main-message-container {
  bottom: 0;
  width: 100%;
  padding: 10px 20px;
}

.chat-message-bottom-send {
  border: none;
  margin-left: 5px;
}

.uploadPictures-container {
  column-gap: 10px;
  row-gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.uploadPictures-col {
  width: 75px;
  height: 75px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uploadPictures-col img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.uploadPictures-add {
  border: 1px dashed #ddd;
  cursor: pointer;
}

.uploadPictures-add label {
  width: 100%;
  height: 100%;
  text-align: center;
  cursor: pointer;
  line-height: 400%;
}

.chat-message-bottom-actions img {
  height: 25px;
}

.chat-show-message-container {
  padding: 10px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  margin: 10px 0;
}

.chat-message {
  margin-top: auto;
  margin-bottom: 10px;
}

.chat-message:last-child {
  margin-bottom: 0;
}

.chat-message-img img {
  height: 35px;
}

.chat-message-text {
  line-height: 1.2;
}

.chat-message-text p {
  margin: 0;
}

.chat-message-name {
  font-weight: bold;
  font-size: 14px;
}

.chat-message-time {
  margin-left: 5px;
  font-size: 12px;
}

.chat-message-text {
  display: block;
}

.chat-side-container a:hover {
  text-decoration: none;
}

.offer-container {
  border: 1px solid #ddd;
  background-color: #fff;
  color: #363636;
  margin: 20px 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
  padding: 10px;
  border-radius: 5px;
}

.offer-container p {
  margin: 0;
  font-weight: bold;
}

.bottom-bar-default {
  position: fixed;
  width: 100%;
  bottom: 0;
  padding: 20px;
  background-color: #fff;
  border-top: 1px solid #ddd;
}

.bottom-bar-default img {
  height: 15px;
}

.rating-container {
  height: 13px;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}

.rating-container img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.home-text-section h2 {
  color: #ff4848;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
}

.home-text-section {
  width: 65%;
  margin: auto;
  padding-bottom: 50px;
}

.home-text-section-container {
  padding: 10px 0;
}

.home-text-section-container h3 {
  font-weight: bold;
  color: #363636;
  font-size: 16px;
  margin: 0;
  margin-bottom: 5px;
}

.home-text-section-container span {
  font-weight: 400;
  color: #646464;
  font-size: 16px;
}

.home-text-section-container-paragrap p {
  font-weight: 400;
  color: #646464;
  font-size: 16px;
  line-height: 1.5;
}
.ride-details-btn {
  margin-left: 3rem;
}

.top-back-bar {
  padding: 20px 0;
  width: auto;
  cursor: pointer;
  display: inline-block;
}

.chatInput {
  padding: 5px !important;
  font-size: 16px !important;
  border-radius: 5px !important;
  border-width: 1px !important;
  border-color: #ddd !important;
  margin-bottom: 10px !important;
  width: 100% !important;
}

.chat-main-message-input textarea {
  margin-bottom: 10px;
}

.payment-container {
  max-width: 600px;
  margin: auto;
  padding: 20px 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 75px;
}

.payment-container h2 {
  font-size: 24px;
  font-weight: bold;
  color: #363636;
}

.payment-main {
  flex: 1 1;
}

.payment-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.payment-price-container {
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.payment-price-container span {
  font-size: 20px;
  font-weight: bold;
}

.payment-price-container p {
  margin: 0;
  padding: 0;
  font-size: 20px;
  margin-right: 10px;
}

.payment-button button {
  padding: 10px 40px;
}

.paymentMethod {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
}

.radio-out {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.radio-in {
  width: 15px;
  height: 15px;
  border-radius: 25px;
  background-color: #fff;
}

.paymentMethod img {
  max-height: 24px;
  margin-left: 10px;
}

.paymentMethod span {
  margin-left: 10px;
}

.radio-active {
  border: 1px solid #ff4848;
}

.radio-active .radio-in {
  background-color: #ff4848;
}

@media screen and (max-width: 992px) {
  .main-form-input-col .autocompleteInput {
    border: 1px solid #ddd;
    padding: 8px 10px;
  }
  .home-text-section {
    width: 100%;
  }
  .result-content-container {
    padding: 20px 15px;
  }
  .leerfahrten-main-background {
    height: 350px;
  }
  .autocompleteContainer {
    left: 0;
    border: none;
    margin-top: 20px;
  }
  .autocompleteItems {
    padding: 10px 0;
    font-size: 16px;
  }
  .noti-flex {
    flex-direction: column;
    align-items: flex-start;
  }
  .details-isuser-container {
    margin-top: 0;
    padding-top: 60px !important;
  }
  .rating-cnt {
    padding-top: 50px;
  }
  .rating-cnt h1 {
    font-size: 30px;
  }
  .rating-cnt h3 {
    font-size: 20px;
  }
  .desktop-hide {
    display: block;
  }
  .price-modal {
    position: fixed;
    z-index: 9999999;
    height: calc(100% - 70px);
  }
  .ride-details-btn {
    margin-left: auto;
  }
  .ride-adress-date {
    display: none;
  }
  /* CHAT */
  .chat-phone .container {
    width: 100%;
    margin: auto;
    max-width: 100%;
  }
  .phone-hide {
    display: none !important;
  }
  .chat-phone .border-container {
    border: none;
    box-shadow: none;
  }
  .bottom-bar-default {
    display: none;
  }
  .chat-main-top-bar {
    position: fixed;
    width: 100%;
    z-index: 999;
  }
  .chat-main-profile-info {
    position: fixed;
    width: 100%;
    margin-top: 62px;
    z-index: 9999999;
  }
  .chat-phone {
    padding-bottom: 0 !important;
  }
  .dashboard-container-privat {
    display: block;
  }
  .dashboard-container-privat div {
    margin-bottom: 5px;
  }
  .chat-phone .chat-side-container,
  .chat-phone .chat-main-container {
    border: none;
  }
  .chat-main-profile-info {
    height: 65px;
  }
  .chat-main-message-container {
    position: fixed;
    background-color: #fff;
    padding-bottom: 20px;
  }
  .chat-message {
    margin: 5px 0;
  }
  .chat-main-inner-container {
    height: auto;
    padding-bottom: 100px;
  }
  .chat-show-message-container {
    margin-top: 137px;
  }
  .chat-phone .chat-inner-wrapper {
    height: auto;
  }
  .chat-phone .col-lg-4,
  .chat-phone .col-lg-8 {
    padding: 0;
  }
  .chat-phone .top-back-bar {
    display: none;
  }
  .chat-phone .chat-side-top-bar,
  .chat-main-top-bar {
    padding: 20px;
  }
  .chat-phone .chat-side-pic img {
    height: 45px;
    width: 45px;
  }

  .navbar-toggle,
  .leerfahrten-departure-sidebar {
    display: block;
  }
  .listing-container {
    padding-top: 0;
  }
  .ant-tabs-content-holder {
    padding: 0 15px;
  }
  .listing-container .container {
    padding: 0 !important;
  }
  .ant-tabs-nav {
    border-top: 1px solid #ddd;
    padding: 0px 15px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  }
  .mobile-margin-container {
    margin-top: -70px;
    margin-bottom: 120px;
  }
  .border-container {
    background-color: #fff;
  }
  .ride-details-body-map,
  .ride-details-footer {
    display: none !important;
  }
  .ride-details-body-map-mobile,
  .ride-details-mobile-contact-container {
    display: block !important;
  }
  .ride-details-mobile-heading {
    display: flex !important;
  }
  .app-ad-container {
    height: 900px;
  }
  .app-add-img {
    left: 10%;
    width: 320px;
    bottom: 0%;
  }
  .ride-details-profile-details-body,
  .ride-details-top-container,
  .ride-details-container .divider {
    display: none !important;
  }
  .ride-details-container {
    border: none !important;
    box-shadow: none !important;
    padding: 0 10px;
  }
  .ride-details-body {
    padding: 0;
  }
  .main-mobile-form-home {
    display: block;
  }
  .ride-details-mobile-top {
    display: block;
  }
  .main-desktop-form-home {
    display: none;
  }
  .search-mobile-form-container {
    display: flex !important;
  }
  #listing-search-container {
    height: auto;
    z-index: 3;
  }
  .listing-container .row {
    margin: 0;
  }
  .result-container {
    border: none;
    padding: 0;
  }
  .map-container {
    display: none;
  }
  .ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
    font-size: 14px;
    padding: 10px;
  }
  .navbar-leerfahrten-brand {
    width: 153px !important;
    cursor: pointer;
  }
  .navbar-navigation,
  .search-main-form {
    display: none;
  }

  .navbar-navigation-mobile {
    display: block;
  }
  .main-form-input-col {
    padding: 5px 0;
  }
  #listing-search-container {
    border-top: 1px solid #ccc !important;
  }
}

@media screen and (min-width: 992px) {
  .navbar-leerfahrten {
    flex-wrap: nowrap;
  }
  .navbar-nav {
    flex-direction: row;
  }
}

@media screen and (max-width: 768px) {
  .app-add-img {
    left: 10%;
    width: 280px;
  }
  .mobile-back-btn {
    display: block;
  }
  .app-ad-container {
    height: 900px;
    overflow: hidden;
  }
  .settings-topbar-header {
    text-align: center;
  }

  .help-container {
    display: none;
  }

  .mobile-hide {
    display: none;
  }

  .settings-container-mobile {
    max-width: 100%;
    width: 100%;
    padding: 0;
    margin-top: 0;
  }

  .settings-container-mobile .border-container {
    border: none;
    border-radius: 0;
  }

  .settings-container-mobile .setting-top-container {
    border-radius: 0;
  }

  .settings-container-row {
    padding: 15px;
  }

  .settings-container-row:hover {
    background-color: #fff;
  }

  .settings-container-mobile .border-container {
    margin-bottom: 0;
    box-shadow: none;
  }

  .settings-container-mobile {
    margin-bottom: 50px;
  }

  .setting-top-header {
    text-align: center;
  }

  .setting-top-container {
    box-shadow: 0px 2px 5px rgba(104, 39, 19, 0.2);
    border-bottom: 2px solid #eee;
  }
  .forgot-password-cnt {
    width: 100%;
    border: none;
    box-shadow: none;
    margin: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,+CAA+C;IAC/C,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EAEZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAY;EACZ,sBAAsB;EAEtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EAEZ,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,qBAAqB;EACrB,yBAAyB;EAEzB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,UAAU;EACV,MAAM;AACR;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,WAAW;EACX,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mDAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB,EAAE,gBAAgB;AAC3C;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mDAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEE,UAAU;AACZ;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,MAAM;EACN,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;;;;;;EAME,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,aAAa;EACb,OAAO;EACP,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAElB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EAGE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EAGE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,SAAS;EACT,OAAO;EACP,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,+CAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,WAAW;EACX,OAAO;EACP,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,OAAO;IACP,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA,SAAS;EACT;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,2CAA2C;EAC7C;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,YAAY;IACZ,UAAU;EACZ;EACA;;;IAGE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8CAA8C;IAC9C,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: auto;\n}\n\nhtml,\n#root {\n  height: 100%;\n}\n\nbody {\n  height: calc(100% - 75px);\n}\n\n.ant-btn {\n  width: 100% !important;\n}\n\n.agb-container h2 {\n  font-size: 18px;\n  margin: 20px 0 10px 0;\n}\n\n.agb-container p {\n  font-size: 14px;\n  margin: 20px 0;\n  color: #333;\n}\n\n.law-container {\n  max-width: 800px;\n  margin: auto;\n}\n\n.law-container h3 {\n  margin-top: 20px;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n@media screen and (min-width: 993px) {\n  .ant-tabs-nav {\n    border-radius: 5px;\n    box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);\n    margin-bottom: 20px;\n    border: 1px solid #cccccc;\n    padding: 0 10px;\n    margin-top: 20px !important;\n  }\n}\n\n/*NAVBAR*/\n.navbar-leerfahrten {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-mobile-body {\n  border-top: 1px solid rgb(241, 242, 246);\n}\n\n.navbar-leerfahrten-brand {\n  width: 153px !important;\n  cursor: pointer;\n}\n.navbar-leerfahrten-brand svg {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #141414;\n  background-color: #fff;\n  border-radius: 5px;\n}\n\n.autocompleteInput {\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  background-color: #f7f7f7;\n}\n\n.autocompleteContainer {\n  background: #fff;\n  border: 1px solid #eee;\n  margin-top: 5px;\n  position: absolute;\n  padding: 10px 15px;\n  border-radius: 5px;\n}\n\n.autocompleteItems {\n  padding: 2px 0;\n  cursor: pointer;\n}\n\n.navbar-toggle {\n  display: none;\n  padding: 0;\n  font-size: 1.09375rem;\n  line-height: 1;\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.4);\n  border: none;\n}\n\n#navbar-toggle-open svg {\n  width: 30px;\n  height: 24px;\n  padding: 3px;\n  color: #ff7474;\n}\n\n#navbar-toggle-close svg {\n  width: 24px;\n  height: 24px;\n  padding: 3px;\n  color: rgb(255, 163, 163);\n  cursor: pointer;\n}\n\n.navbar-navigation-mobile {\n  z-index: 9999;\n  background-color: white;\n  position: fixed;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  display: none;\n  transform: translateX(100%);\n  transition: all 0.1s;\n  overflow: auto;\n}\n\n.mobile-button-body .navbar-mobile-col {\n  padding: 5px 0;\n}\n\n.mobile-button-row {\n  width: 100%;\n}\n\n.mobile-button-body {\n  padding: 15px;\n}\n\n.navbar-row-padding {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.navbar-mobile-flex-row {\n  border-bottom-width: 1px;\n  border-color: rgb(241, 242, 246);\n  display: flex;\n  flex-direction: row;\n  padding-bottom: 15px;\n  padding-top: 15px;\n  position: relative;\n  min-width: 254px;\n  border-bottom-style: solid;\n}\n\n.navbar-mobile-row-icon {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  -moz-box-pack: center;\n  justify-content: center;\n}\n\n.navbar-mobile-row-icon-cnt {\n  height: 24px;\n  width: 24px;\n  margin-right: 10px;\n  color: #ff4848;\n}\n\n.navbar-mobile-row-icon-cnt svg {\n  fill: #ff4848;\n}\n\n.navbar-body-text-cnt {\n  display: flex;\n  flex: 1 1 0%;\n  flex-direction: column;\n  -moz-box-pack: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.navbar-body-text-flex {\n  display: flex;\n  flex-direction: row;\n}\n\n.text-span-flex {\n  -moz-box-align: center;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  min-height: 23px;\n}\n\n.fEFwefw {\n  -moz-box-align: center;\n  align-items: center;\n  color: rgb(255, 163, 163);\n  display: flex;\n  flex-direction: column;\n  height: 24px;\n  -moz-box-pack: center;\n  justify-content: center;\n  margin-left: 10px;\n  width: 20px;\n}\n\n.settings-subhead {\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #363636;\n  font-size: 14px;\n  margin-bottom: 15px;\n}\n\n.freight-btn-prm {\n  border-radius: 5px !important;\n  background-color: #ff4848 !important;\n  color: #fff !important;\n  border: none;\n}\n\n.password-tip {\n  color: #5c5c5c;\n  font-size: 14px;\n  text-align: right;\n  margin-left: auto;\n  width: 100%;\n  display: block;\n  font-weight: bold;\n}\n\n.button-mobile-body-row {\n  background: 0 0;\n  border: none;\n  font-size: inherit;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.navbar-mobile-col {\n  background-color: #fff;\n}\n\n.navbar-mobile-divider {\n  -webkit-box-align: end;\n  align-items: flex-end;\n  background-color: #f6f1f1;\n  display: -webkit-box;\n  display: flex;\n  height: 40px;\n  padding: 4px 16px;\n}\n\n.profile-info-general-text,\n.profile-info-general-text-right {\n  font-weight: bold;\n  color: #363636;\n  display: block;\n  width: 100%;\n  font-size: 14px;\n}\n\n.profile-info-general-text-right {\n  color: #ff4848;\n  text-align: right;\n}\n\n.details-isuser-container {\n  max-width: 600px;\n  margin: auto;\n  margin-top: 100px;\n}\n\n.navbar-mobile-divider h2 {\n  color: #c3a1a1;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 1.2px;\n  line-height: 20px;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.header-no-bg {\n  background-color: none;\n  position: fixed;\n  width: 100%;\n  z-index: 5;\n  top: 0;\n}\n\n.header-no-bg nav {\n  border: none !important;\n}\n\n.header-no-bg-active nav {\n  border: none !important;\n}\n\n.header-no-bg-active #navbar-toggle-open svg {\n  color: rgb(255, 163, 163);\n}\nheader {\n  transition: all 0.1s;\n}\n\n.header-no-bg-active {\n  background-color: #fff !important;\n  position: fixed;\n  width: 100%;\n  z-index: 5;\n  box-shadow: 0px 2px 1px rgba(104, 39, 19, 0.15);\n}\n\n.home-trust-container {\n  padding: 15px;\n}\n\n.home-trust-container img {\n  height: 70px;\n}\n\n.home-trust-container p {\n  margin-bottom: 5px;\n  line-height: 14px;\n  font-weight: bold;\n  color: #141414;\n}\n\n.home-trust-section {\n  padding: 50px 0;\n}\n\n.home-trust-text-container {\n  margin-left: 10px;\n}\n\n.home-trust-container span {\n  margin: 0;\n  line-height: 1.2;\n  color: #5c5c5c;\n}\n\n.navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  color: #ff4848;\n}\n\n.navbar-navigation-mobile .navbar-leerfahrten {\n  padding: 20px 0;\n}\n\n.navbar-leerfahrten-brand .cls-1 {\n  fill: #fff;\n}\n.navbar-leerfahrten-brand .st0 {\n  fill: #141414;\n}\n.navbar-leerfahrten-brand .st1 {\n  fill: #ff4848;\n}\n.navbar-leerfahrten-brand .cls-2 {\n  fill: #141414;\n}\n.navbar-leerfahrten-brand .cls-3 {\n  fill: #ff4848;\n}\n.navbar-leerfahrten-brand .cls-1 {\n  fill: #fff;\n}\n.navbar-leerfahrten-brand .cls-2 {\n  fill: #141414;\n}\n.navbar-leerfahrten-brand .cls-3 {\n  fill: #ff4848;\n}\n\na {\n  text-decoration: none;\n  color: #141414;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nheader nav {\n  height: 75px;\n}\n\n.navbar-nav a {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: #ff4848;\n}\n\n.navbar-light .navbar-nav .nav-link.active {\n  color: #ff4848;\n}\n\n.navbar-light .navbar-nav .nav-link:hover {\n  color: #ff5656;\n}\n\n.input-group {\n  border-radius: 5px;\n  border: 1px solid #fff;\n}\n\n.list-control {\n  border: 1px solid #fff;\n  border-radius: 5px !important;\n}\n\n.rating-cnt {\n  text-align: center;\n  margin: auto;\n  height: 100%;\n  padding-top: 100px;\n  max-width: 600px;\n}\n\n.rating-topbar {\n  padding: 20px 0;\n  justify-content: flex-end;\n}\n\n.close-button {\n  border: 1px solid #999 !important;\n  border-radius: 5px;\n  background-color: #fff !important;\n  color: #141414 !important;\n}\n\n.rating-cnt h3 {\n  font-weight: bold;\n  font-size: 24px;\n  margin: 0;\n  color: #363636;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.rating-cnt h1 {\n  font-weight: bold;\n  font-size: 36px;\n  margin: 0;\n  margin-bottom: 40px;\n  color: #363636;\n}\n\n.rating-cnt button {\n  font-weight: bold;\n  padding: 10px 40px;\n  width: 100%;\n}\n\n.ant-rate {\n  font-size: 40px;\n}\n\n.form-control {\n  border-radius: 5px !important;\n}\n\n.list-control:focus {\n  border: 1px solid #ff4848;\n}\n\n.input-group-text {\n  border: 1px solid #fff;\n}\n\n#brand-logo {\n  width: 140px;\n}\n\n.main-default {\n  padding: 100px 0 20px 0;\n}\n\n.border-container {\n  border-radius: 5px;\n  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);\n  margin-bottom: 20px;\n  border: 1px solid #cccccc;\n}\n\n.auth-wrapper {\n  padding: 40px;\n  border-radius: 5px;\n  box-shadow: 0px 2px 5px rgba(104, 39, 19, 0.2);\n  border: 1px solid #cccccc;\n}\n\n.mid-heading {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #ff4848;\n  margin-bottom: 15px;\n}\n\n.toast-container {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 9999;\n  text-align: center;\n  font-weight: bold;\n}\n\n.error-toast {\n  background-color: rgb(255, 89, 89) !important;\n  box-shadow: 2px 0px 5px rgba(104, 39, 19, 0.2);\n  color: white;\n}\n\n.success-toast {\n  background-color: rgb(86, 215, 74) !important;\n  box-shadow: 2px 0px 10px rgba(104, 39, 19, 0.2);\n  color: white;\n}\n\n.ride-details-container {\n  margin-bottom: 100px;\n}\n\n.toast-container .toast {\n  width: 100%;\n  max-width: 100%;\n  background-color: #fff;\n}\n\n.form-label {\n  color: #999;\n}\n\n.auth-container {\n  max-width: 500px;\n  margin: auto;\n  padding: 50px 0;\n}\n\n.auth-wrapper {\n  position: relative;\n}\n\n.leerfahrten-container {\n  margin-top: 75px;\n  min-height: 100%;\n}\n\n.footer-col-inner {\n  margin-bottom: 25px;\n}\n\n.listing-container nav {\n  height: auto !important;\n}\n\n.listing-container nav a {\n  width: 25%;\n  text-align: center;\n  font-size: 1rem;\n  color: #ff4848;\n}\n\n.listing-container .nav-tabs .nav-link.active {\n  color: #ff4848;\n}\n\n.listing-container .nav-tabs .nav-link.active,\n.nav-tabs .nav-link.active:focus,\n.nav-tabs .nav-link.active:hover,\n.nav-tabs .nav-link:hover {\n  border-bottom: 2px solid #ff4848;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #cccccc;\n}\n\n.filterPanel {\n  padding: 16px 0;\n}\n\n.result-inner {\n  background: #ffffff;\n  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);\n  border-radius: 5px;\n  padding: 10px;\n  border: 1px solid #cccccc;\n  transition: 0.1s;\n}\n\n.result-cell {\n  margin-bottom: 15px;\n}\n\n.desktop-hide {\n  display: none;\n}\n\n.mobile-back-btn {\n  display: none;\n}\n\n.contact-flex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n}\n\n.contact-flex-inner {\n  display: flex;\n  align-items: center;\n}\n\n.contact-flex-inner img {\n  margin-right: 20px;\n}\n\n.contact-flex p {\n  margin: 0;\n}\n\n.contact-info-text h3 {\n  margin-top: 50px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n#map {\n  height: calc(100vh - 75px - 58px - 40px);\n  width: 100%;\n  position: relative;\n  background-color: #eee;\n  border-radius: 5px;\n  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);\n  border: 1px solid #cccccc;\n  margin-left: 10px;\n}\n\n#map img {\n  width: 100%;\n  height: 100%;\n  border-radius: 5px !important;\n}\n\n#map .filter {\n  height: 100%;\n  z-index: 97;\n  position: absolute;\n  width: 100%;\n  top: 0;\n}\n\n.allFilters {\n  background-color: #fff;\n  z-index: 97;\n  position: absolute;\n  transition: all 0.3s;\n  height: 100%;\n  width: 90%;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.confirm-email-container {\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  margin-top: 150px;\n  flex-direction: column;\n  max-width: 600px;\n}\n\n.confirm-email-container h1 {\n  font-size: 24px;\n  color: #141414;\n  margin-bottom: 10px;\n}\n\n.confirm-email-container p {\n  font-size: 16px;\n  color: #141414;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.price-modal {\n  position: absolute;\n  width: 100%;\n  background-color: #fff;\n  height: 0;\n  bottom: 0;\n  border-radius: 5px;\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: all 0.2s;\n  transform: translateY(100%);\n  z-index: 999999999;\n  border-top: 1px solid #ddd;\n}\n.price-modal form {\n  display: none;\n}\n\n.price-modal-top,\n.price-modal-bottom {\n  padding: 20px;\n  text-align: center;\n}\n\n.price-modal-body h2 {\n  font-weight: bold;\n  color: #363636;\n  font-size: 24px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.price-modal-body input {\n  width: 300px;\n  text-align: center;\n  margin: auto;\n  font-weight: bold;\n  font-size: 24px;\n}\n\n.price-modal-bottom {\n  text-align: center;\n}\n\n.price-modal-bottom button {\n  padding: 10px 40px;\n}\n\n.price-modal-body {\n  padding: 0 20px;\n}\n\n.filter-bg {\n  background-color: rgba(0, 0, 0, 0.6);\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  opacity: 0;\n  z-index: 96;\n  transition: all 0.2s;\n  border-radius: 5px;\n}\n\n.end-ride-inner {\n  padding: 15px;\n}\n\n.end-ride-route-dot {\n  height: 10px;\n  width: 10px;\n  background-color: #ff4848;\n  border-radius: 50%;\n}\n\n.dashboard-rating-body {\n  max-height: 300px;\n  overflow-y: scroll;\n}\n\n.subRide-finish-container {\n  background-color: #47c653;\n  color: #fff;\n  text-align: center;\n  font-weight: bold;\n  font-size: 16px;\n  padding: 10px 0;\n}\n\n.subRide-finish-container a {\n  color: #fff;\n}\n\n.end-ride-route-line {\n  width: 20px;\n  height: 2px;\n  background-color: #ff4848;\n  transform: rotate(90deg);\n  margin: 15px 0;\n}\n\n.end-ride-route-text {\n  line-height: 1;\n  text-align: left;\n  margin-left: 5px;\n  font-weight: bold;\n}\n\n.end-ride-route-empty {\n  height: 25px;\n}\n\n.end-ride-inner h2 {\n  font-weight: bold;\n  color: #141414;\n  font-size: 1rem;\n  text-align: left;\n}\n\n.filterPanel button {\n  background-color: #fff;\n  border: 1px solid #ff4848;\n  color: #ff4848;\n  border-radius: 5px;\n  padding: 5px 20px;\n  align-self: center;\n}\n\n.app-ad-container {\n  width: 100%;\n  background: url(\"app-bg.png\");\n  background-position: bottom;\n  background-size: cover;\n  position: relative;\n  padding: 50px 0;\n}\n\n.body-height {\n  height: 1000px;\n}\n\n.app-download-img {\n  margin-top: 20px;\n}\n\n.app-download-img img {\n  width: 130px;\n  margin-right: 5px;\n}\n\n.app-heading {\n  font-size: 40px;\n  line-height: 48px;\n  color: #fff;\n  font-weight: bold;\n  margin: 0;\n  width: 40%;\n  margin-bottom: 10px;\n}\n\n.app-sub {\n  font-size: 16px;\n  color: #fff;\n  font-weight: 400;\n  margin: 0;\n}\n\n.app-add-img {\n  position: absolute;\n  right: 20%;\n  bottom: -12%;\n  width: 260px;\n}\n\n.filterPanel button svg {\n  height: 15px;\n}\n\n.result-content-container {\n  padding: 20px 0;\n}\n\n.result-container {\n  z-index: 4 !important;\n  background-color: #fff;\n  padding-right: 20px;\n}\n\n.map-container {\n  padding-left: 0 !important;\n}\n\n.p-name {\n  font-weight: bold;\n}\n\n.like-section {\n  text-align: right;\n  font-size: 14px;\n}\n\n.sort-text {\n  margin: 0;\n  color: #ff4848;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.ant-select-selector {\n  border: none !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n}\n\n.filterPanel button {\n  align-self: center;\n}\n\n.like-section img {\n  height: 18px;\n}\n\n.like-section p {\n  margin: 0;\n  font-weight: bold;\n  color: #ff4848;\n  margin-top: 5px;\n}\n\n.title-icon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.result-inner-container {\n  flex-direction: column;\n}\n\n#listing-search-container {\n  padding: 10px;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  height: 64px;\n  z-index: 99;\n}\n\n.checkbox-custom,\n.radio-custom {\n  opacity: 0;\n  position: absolute;\n}\n\n.checkbox-custom,\n.checkbox-custom-label,\n.radio-custom,\n.radio-custom-label {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 5px;\n  cursor: pointer;\n}\n\n.checkbox-custom-label,\n.radio-custom-label {\n  position: relative;\n  font-size: 18px;\n}\n\n.checkbox-custom + .checkbox-custom-label:before,\n.radio-custom + .radio-custom-label:before {\n  content: \"\";\n  background: #fff;\n  border: 2px solid #ddd;\n  display: inline-block;\n  vertical-align: middle;\n  width: 22px;\n  height: 22px;\n  padding: 2px;\n  margin-right: 10px;\n  text-align: center;\n  margin-bottom: 5px;\n}\n\n.checkbox-custom:checked + .checkbox-custom-label:before {\n  background: #ff4848;\n  box-shadow: inset 0px 0px 0px 4px #fff;\n  border: 1px solid #ff4848;\n}\n\n.radio-custom + .radio-custom-label:before {\n  border-radius: 50%;\n}\n\n.radio-custom:checked + .radio-custom-label:before {\n  background: #ff4848;\n  box-shadow: inset 0px 0px 0px 4px #fff;\n  border: 1px solid #ff4848;\n}\n\n.checkbox-custom:focus + .checkbox-custom-label,\n.radio-custom:focus + .radio-custom-label {\n  outline: 1px solid #ddd; /* focus style */\n}\n\n.text-custom-container {\n  border: 1px solid #ddd;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  transition: all 0.1s;\n}\n\n.text-custom-container:focus {\n  border: 1px solid #ff4848;\n}\n\n.route-adress-col {\n  flex: 1;\n  overflow: hidden;\n}\n\n.profile-img img {\n  height: 35;\n  width: 35px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.profile-img {\n  margin-right: 10px;\n}\n\n.profile-details {\n  line-height: 1;\n}\n\n.profile-details {\n  flex-direction: column;\n}\n\n.profile-link {\n  font-size: 14px;\n}\n\n.profile-link img {\n  height: 13px;\n  margin-right: 5px;\n}\n\n.route-address {\n  line-height: 1;\n  overflow: hidden;\n  font-size: 14px;\n}\n\n.route-address-col {\n  width: 100%;\n  overflow: hidden;\n}\n\n.route-address span {\n  font-size: 14px;\n  color: #969696;\n  line-height: 1;\n}\n\n.divider-dot {\n  height: 10px;\n  width: 10px;\n  background-color: #ff4848;\n  border-radius: 50%;\n}\n\n.divider-waypoint-dot {\n  height: 10px;\n  width: 10px;\n  background-color: #fff;\n  border: 1px solid #ff4848;\n  border-radius: 50%;\n}\n\n.contact-subhead {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 0 !important;\n}\n\n.bold-text {\n  font-weight: bold;\n}\n\n.ant-upload-picture-card-wrapper {\n  margin-top: 20px;\n}\n\n.upload-outside {\n  border: 2px solid #47c653;\n  padding: 5px;\n  border-radius: 100%;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n}\n\n.pictures-row {\n  margin-bottom: 10px;\n}\n\n.pictures-row span {\n  font-weight: bold;\n  display: block;\n  width: 100%;\n  margin-bottom: 5px;\n}\n\n.pictures-row-flex {\n  column-gap: 10px;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  flex-direction: row !important;\n}\n\n.custom-link {\n  cursor: pointer;\n  background-color: #ff4848;\n  padding: 2px 10px;\n  border-radius: 5px;\n  color: #fff !important;\n  font-weight: bold;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.custom-link:hover {\n  background-color: #ff6262;\n}\n\n.custom-link-white {\n  cursor: pointer;\n  background-color: #fff;\n  padding: 2px 10px;\n  border-radius: 5px;\n  color: #141414 !important;\n  font-weight: bold;\n  border: 1px solid #eee;\n}\n\n.forgot-password-cnt {\n  width: 400px;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);\n  border: 1px solid #cccccc;\n  margin: auto;\n  margin-top: 120px;\n  text-align: center;\n}\n\n.forgot-password-cnt h1 {\n  font-size: 24px;\n  font-weight: bold;\n  color: #141414;\n  text-align: center;\n  margin: 0;\n  padding: 10px 0;\n}\n\n.forgot-password-cnt p {\n  font-size: 18px;\n  color: #363636;\n  text-align: center;\n  margin: 0;\n  padding: 10px 20px;\n}\n\n.forgot-password-cnt a {\n  padding: 10px 20px !important;\n  text-align: center !important;\n  display: block;\n}\n\n.forgot-password-cnt form {\n  padding: 0 20px;\n}\n\n.forgot-password-cnt input {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin: 10px 0;\n  font-size: 16px;\n}\n\n.participants-btn-row {\n  column-gap: 5px;\n  padding-right: 15px;\n}\n\n.participants-btn-row .green-btn {\n  background-color: #47c653 !important;\n  border: #47c653 !important;\n}\n\n.forgot-password-cnt button {\n  width: 100%;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.prm-btn {\n  cursor: pointer;\n  background-color: #ff4848;\n  padding: 5px 10px;\n  border-radius: 5px;\n  color: #fff !important;\n  font-weight: bold;\n  border: none;\n}\n\n.prm-btn:hover {\n  background-color: #ff6262;\n  border: none;\n}\n\n.custom-link-white:hover {\n  background-color: #f7f7f7;\n}\n\n.noti-inner {\n  column-gap: 10px;\n}\n\n.noti-img img {\n  height: 35px;\n}\n\n.noti-text {\n  color: #141414;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.noti-date {\n  color: #363636;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.noti-link {\n  color: #ff4848;\n}\n\n.noti-check {\n  background-color: #fafafa;\n  border-radius: 5px;\n  color: #ddd;\n  padding: 5px 10px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n}\n\n.noti-check:hover {\n  background-color: #47c653;\n  color: #fff;\n  border: 1px solid #47c653;\n}\n\n.noti-flex {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.upload-done {\n  background-color: #47c653;\n  border-radius: 100%;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  margin: auto;\n}\n\n.ant-upload.ant-upload-select-picture-card {\n  width: 100% !important;\n  height: 150px !important;\n}\n\n.contact-info img {\n  width: 20px;\n}\n\n.route-row {\n  margin: 2px 0;\n}\n\n.divider-line {\n  width: 2px;\n  height: 10px;\n  margin: 0 10px;\n  background-color: #ff4848;\n  margin-left: 14px;\n}\n\n.route-section {\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.route-divider {\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.route-address p {\n  margin: 0;\n  line-height: 1;\n  font-size: 14px;\n  color: #141414;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  min-height: 20px;\n}\n\n.chats-top-bar-number {\n  column-gap: 10px;\n}\n\n.chats-top-bar-number p {\n  margin: 0;\n  margin-right: 5px;\n}\n\n.details-button-section {\n  background-color: #ff4848;\n  color: #fff;\n  border-radius: 5px;\n  padding: 5px 15px;\n  font-size: 14px;\n}\n\n.details-button-section:hover {\n  color: #fff;\n  background-color: #ff4848;\n}\n\n.settings-avatar img {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  object-fit: cover;\n}\n\n.listing-container {\n  padding-top: 56px;\n}\n\n.footer-heading {\n  font-size: 16px;\n  font-weight: bold;\n  color: #363636;\n  margin-bottom: 10px;\n}\n\nfooter ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\nfooter ul li {\n  margin-bottom: 5px;\n  color: #4f4f4f;\n}\n\nfooter ul li a {\n  color: #4f4f4f;\n}\n\nfooter ul li a:hover {\n  color: #ff4848;\n}\n\n.footer-bottom {\n  border-top: 1px solid #cccccc;\n  width: 100%;\n  padding: 10px 0;\n}\n\n.footer-top {\n  border-top: 1px solid #cccccc;\n  border-bottom: 1px solid #cccccc;\n  margin: 0 0 20px 0;\n}\n\n.profile-tab-top {\n  padding: 10px;\n}\n\n.profile-tab-top-image img {\n  height: 40px;\n  width: 40px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.profile-tab-top-details {\n  flex-direction: column;\n  line-height: 1;\n  margin-left: 5px;\n}\n\n.profile-name {\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0;\n  padding: 0;\n  margin-right: 5px;\n}\n\n.modal-header {\n  padding: 10px !important;\n}\n\n.chats-top-bar {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n}\n\n.small-heading {\n  font-weight: bold;\n  font-size: 14px;\n  color: #363636;\n  padding: 15px 0;\n  margin: 0;\n}\n\n.divider {\n  height: 1px;\n  background-color: #cccccc;\n  width: 100%;\n}\n\n.help-link-img img {\n  height: 25px;\n}\n\n.help-link-text {\n  line-height: 1;\n  margin-left: 10px;\n}\n\n.help-link-text h3 {\n  font-weight: bold;\n  margin: 0;\n  color: #363636;\n  font-size: 14px;\n}\n\n.help-link-text p {\n  color: #363636;\n  margin: 0;\n  padding: 0;\n}\n\n.help-link {\n  padding: 10px 0;\n}\n\n.dashboard-container-top {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n}\n\n.container-heading {\n  font-weight: bold;\n  color: #363636;\n  margin: 0;\n  font-size: 14px;\n}\n\n.dashboard-body-row {\n  padding: 10px;\n}\n\n.order-date {\n  color: #363636;\n  font-size: 14px;\n}\n\n.order-date-bold {\n  font-weight: bold;\n  margin-right: 5px;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: #ff5656 !important;\n}\n\n.dashboard-body-row:hover {\n  background-color: #eeeeee;\n}\n\n.dashboard-pagination-container {\n  padding: 10px;\n  border-top: 1px solid #cccccc;\n  text-align: right;\n}\n\n.container-heading-icon img {\n  height: 20px;\n  margin-right: 10px;\n}\n\n.dashboard-body-row .btn {\n  padding: 0.175rem 0.75rem;\n}\n\n.dashboard-pagination-container .btn {\n  padding: 0.275rem 0.75rem;\n}\n\n.dashboard-container-empty-body {\n  padding: 20px 0;\n  text-align: center;\n  font-weight: bold;\n}\n\n.rating-img-container img {\n  height: 35px !important;\n  width: 35px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.modal-content {\n  border-radius: 5px !important;\n}\n\n.participants-row {\n  flex-basis: 100%;\n  flex-wrap: wrap;\n  column-gap: 10px;\n  row-gap: 10px;\n}\n\n.participants-row-img {\n  height: 45px;\n  width: 60px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.freight-row {\n  padding: 5px 10px;\n}\n\n.freight-btn {\n  border-radius: 5px;\n  width: 100%;\n}\n\n.ant-tabs-ink-bar {\n  background: #ff4848 !important;\n}\n\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #ff4848 !important;\n}\n\n.ant-tabs-tab:hover {\n  color: #ff4848 !important;\n}\n\n.rating-text-container p {\n  margin: 0;\n  padding: 0;\n}\n\n.rating-text-container {\n  line-height: 1;\n  margin-left: 5px;\n}\n\n.rating-text-top p {\n  margin-right: 5px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.rating-text-message {\n  padding-top: 2px;\n  font-size: 14px;\n}\n\n.rating-date-container {\n  margin-left: auto;\n  text-align: right;\n  font-size: 14px;\n}\n\n.list-search-control {\n  transition: 0.1s;\n}\n\n.list-search-control:focus {\n  border: 1px solid #ff4848;\n  transform: scale(110%) !important;\n}\n\n.header-user-img {\n  border-radius: 50%;\n}\n\n.header-user-img img {\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  border: 1px solid #fff;\n  object-fit: cover;\n}\n\n.header-user-name {\n  font-weight: bold;\n  font-size: 16px;\n  margin-right: 10px;\n}\n\n.header-icon img {\n  height: 20px;\n  width: 20px;\n}\n\n.help-link-img {\n  width: 30px;\n}\n\n.profile-complete-top {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n}\n\n.profile-complete-body {\n  padding: 10px;\n}\n\n.profile-complete-item {\n  margin-bottom: 5px;\n}\n\n.profile-complete-item img {\n  height: 15px;\n  margin-right: 5px;\n}\n\n.profile-complete-text {\n  font-weight: bold;\n  color: #363636;\n}\n\n.leerfahrten-main-background {\n  background: url(\"l24-bg3t.png\");\n  height: 450px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  z-index: 1;\n  position: relative;\n}\n\n.leerfahrten-main-background h1 {\n  padding-top: 100px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.leerfahrten-main {\n  background-color: #fff;\n}\n\n.leerfahrten-main-form {\n  background-color: white;\n  margin-top: -25px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  box-shadow: 0px 2px 2px rgba(104, 39, 19, 0.15);\n  position: relative;\n  z-index: 4;\n}\n\n.col,\n.col-1,\n.col-10,\n.col-11,\n.col-12,\n.col-2,\n.col-3,\n.col-4,\n.col-5,\n.col-6,\n.col-7,\n.col-8,\n.col-9,\n.col-auto,\n.col-lg,\n.col-lg-1,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-lg-auto,\n.col-md,\n.col-md-1,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-md-auto,\n.col-sm,\n.col-sm-1,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-sm-auto,\n.col-xl,\n.col-xl-1,\n.col-xl-10,\n.col-xl-11,\n.col-xl-12,\n.col-xl-2,\n.col-xl-3,\n.col-xl-4,\n.col-xl-5,\n.col-xl-6,\n.col-xl-7,\n.col-xl-8,\n.col-xl-9,\n.col-xl-auto {\n  z-index: 3;\n}\n\n.leerfahrten-main-form .ant-input-affix-wrapper,\n.leerfahrten-main-form .ant-btn-lg,\n.search-main-form .ap-input,\n.search-main-form .ap-hint,\n.search-main-form .ant-btn-lg {\n  border-radius: 5px !important;\n}\n\n.search-main-form .ap-input,\n.search-main-form .ap-hint {\n  border: none;\n  background-color: #f1f1f1;\n}\n\n.search-main-form .ap-input:focus,\n.search-main-form .ap-hint:focus,\n.search-main-form .ant-input-affix-wrapper-focused {\n  border: 1px solid #ff4848;\n}\n\n.leerfahrten-main-form .ant-btn-lg,\n.search-main-form .ant-btn-lg {\n  background-color: #ff4848;\n  color: white;\n  border: #ff4848;\n  width: 100%;\n  height: 100%;\n}\n\n.ant-tabs-tab {\n  margin: 0;\n}\n\n.search-main-form .ant-input-affix-wrapper > input.ant-input {\n  background-color: #f1f1f1;\n}\n\n.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {\n  padding: 15px 20px;\n  font-size: 16px;\n}\n\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {\n  justify-content: space-between !important;\n  width: 100%;\n}\n\n.search-main-form .ap-input,\n.search-main-form .ap-hint {\n  transition: all 0.1s;\n}\n\n.search-main-form .ap-input:focus,\n.search-main-form .ap-hint:focus {\n  transform: scale(101%) !important;\n  z-index: 99;\n}\n\n.header-no-bg nav {\n  background-color: none;\n  border-bottom: none;\n}\n\n.header-no-bg .navbar-light .navbar-nav .nav-link {\n  color: #fff;\n}\n\n.leerfahrten-container-no-margin {\n  min-height: calc(100vh - 268px);\n}\n\n.header-icon svg {\n  height: 20px;\n  width: 20px;\n  color: #ff4848;\n  fill: #ff4848;\n}\n\n.header-bg {\n  background-color: #fff;\n  border-bottom: 1px solid #cccccc;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 100;\n}\n\n.header-bg #navbar-toggle-open svg {\n  color: #ff5656;\n}\n\n.create .header-no-bg .navbar-light .navbar-nav .nav-link {\n  color: #ff4848;\n}\n\n.create .header-no-bg .header-icon svg {\n  fill: #ff4848 !important;\n}\n\n.leerfahrten-create-input-container {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.leerfahrten-create-btn-cnt {\n  position: fixed;\n  bottom: 0;\n  padding: 40px 0;\n  width: 100%;\n}\n\n.leerfahrten-create-btn-cnt .btn {\n  padding: 10px 40px;\n  font-weight: bold;\n}\n\n.create-container {\n  flex-direction: column;\n  max-width: 600px;\n  margin: auto;\n}\n\n.leerfahrten-create-text-container {\n  text-align: center;\n  margin: 50px 0;\n}\n\n.leerfahrten-create-text-container h1 {\n  font-weight: bold;\n  font-size: 36px;\n  margin: 0;\n  color: #363636;\n}\n\n.leerfahrten-create-text-container p {\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0;\n  color: #999;\n}\n\n.input-custom-container {\n  border: 1px solid #ddd;\n  padding: 10px 10px 10px 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.settings-topbar {\n  background-color: #f1f1f1;\n  padding: 10px 0;\n}\n\n.settings-topbar-header {\n  color: #141414;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.main-mobile-form-home {\n  display: none;\n}\n\n.setting-top-container {\n  background-color: #ff4848;\n  color: white;\n  padding: 10px 10px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.setting-top-header {\n  font-weight: bold;\n  font-size: 14px;\n  color: white;\n  margin: 0;\n}\n\n.settings-container-row {\n  padding: 5px 10px;\n  background-color: #fff;\n  border-radius: 5px;\n  display: block;\n}\n\n.settings-container-row:hover {\n  background-color: #f1f1f1;\n}\n\n.settings-container-link {\n  font-weight: bold;\n  color: #141414;\n  font-size: 14px;\n}\n\n.settings-container-link svg {\n  height: 10px;\n}\n\n.settings-container-mobile {\n  margin-top: 1.5rem;\n}\n\n.leerfahrten-input-container {\n  margin-bottom: 10px;\n}\n\n.leerfahrten-input-container label {\n  font-weight: bold;\n  font-size: 14px;\n  color: #363636;\n  margin-bottom: 5px;\n}\n.leerfahrten-input-container input {\n  width: 100%;\n  font-weight: bold;\n  font-size: 14px;\n  color: #363636;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 5px;\n  transition: all 0.1s;\n}\n\n.leerfahrten-input-container input:focus {\n  transform: scale(102%);\n  border: 1px solid #ff4848;\n}\n\n.leerfahrten-settings-form {\n  padding: 10px;\n}\n\n.settings-header {\n  font-weight: bold;\n  font-size: 16px;\n  margin: 0;\n  padding: 10px;\n}\n\n.leerfahrten-main-form .col-lg-5,\n.leerfahrten-main-form .col-md-12,\n.leerfahrten-main-form .col-12,\n.search-main-form .col-lg-5,\n.search-main-form .col-md-12,\n.search-main-form .col-12 {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.ant-input-prefix {\n  margin-right: 10px !important;\n}\n\n.leerfahrten-departure-sidebar {\n  z-index: 9999;\n  background-color: white;\n  position: fixed;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  display: none;\n  left: 0;\n  transform: translateX(100%);\n  transition: all 0.1s;\n  overflow: auto;\n}\n\n.leerfahrten-departure-sidebar .ap-dropdown-menu {\n  position: fixed !important;\n  top: 66px !important;\n  box-shadow: none !important;\n}\n\n.departure-header-close {\n  cursor: pointer;\n}\n\n.departure-header-close,\n.departure-header-right {\n  width: 38px;\n  min-width: 38px;\n  max-width: 38px;\n}\n\n.ap-dataset-places div {\n  background-color: #fff !important;\n}\n\n.ap-dataset-places div:hover {\n  background-color: #fff !important;\n}\n\n.departure-sidebar-header {\n  flex-direction: row;\n  padding: 10px 10px;\n  -webkit-box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.1);\n  box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.1);\n}\n\n.departure-header-input {\n  width: 100%;\n}\n\n.departure-header-input input {\n  border: none !important;\n  width: 100% !important;\n}\n\n.departure-header-close svg {\n  height: 18px;\n  width: 18px;\n  color: #717fa4;\n}\n\n.main-form-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-size: 16px;\n}\n\n.main-form-input-mobile {\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.main-form-input-mobile svg {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n}\n\n.main-form-input-mobile p {\n  margin-bottom: 0;\n  font-size: 16px;\n}\n\n.main-form-input-mobile span {\n  color: #bbb;\n  font-size: 16px;\n}\n\n#departure-input,\n#destination-input {\n  font-size: 16px;\n}\n\n.search-mobile-container-text {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 0;\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.search-main-form-mobile {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(51, 51, 51, 0.4);\n  z-index: 101;\n  transition: all 0.1s;\n  transform: translateY(-100%);\n}\n\n.mobile-search-form-body {\n  margin-top: 20px;\n}\n\n.mobile-search-form-body .ant-input-affix-wrapper {\n  border: none;\n  background-color: #f1f1f1;\n  border-radius: 5px;\n}\n\n.mobile-search-form-body .ant-input-affix-wrapper input {\n  background-color: #f1f1f1;\n}\n\n.mobile-search-form-body .ant-btn {\n  width: 100%;\n  border-radius: 5px;\n  color: white;\n  background-color: #ff4848;\n  border: none;\n}\n\n.mobile-search-form-body .row {\n  margin: 0;\n}\n\n.main-form-mobile-search {\n  padding: 20px;\n  background-color: #fff;\n  box-shadow: 0px 2px 5px rgba(58, 58, 58, 0.4);\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.search-mobile-container-close {\n  width: 11px;\n  height: 20px;\n  position: relative;\n  margin-right: 24px;\n  cursor: pointer;\n  color: #ff5656;\n}\n\n.search-mobile-container-icon {\n  width: 19px;\n  height: 20px;\n  cursor: pointer;\n  color: #ff5656;\n  margin-left: 12px;\n}\n.main-desktop-form-home {\n  display: block;\n}\n\n.search-mobile-form-container {\n  display: none !important;\n}\n\n.ride-details-profile-details-body {\n  padding: 10px;\n  flex-direction: column;\n}\n\n.ride-details-profile-details-row {\n  padding-bottom: 5px;\n}\n\n.ride-details-profile-details-text {\n  font-size: 14px;\n  color: #141414;\n  font-weight: 400;\n  margin-right: 5px;\n}\n\n.ride-details-profile-details-var {\n  color: #ff4848;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.ride-details-profile-details-icon {\n  width: 17px;\n  height: auto;\n  margin-right: 10px;\n  color: #141414;\n}\n\n.ride-details-profile-details-contact {\n  margin-top: 10px;\n  width: 100%;\n}\n\n.ride-details-profile-details-contact button {\n  border-radius: 5px !important;\n  color: white;\n  background-color: #ff4848 !important;\n  width: 100%;\n  border: none;\n}\n\n.ride-details-top-container-heading {\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.ride-details-top-container {\n  padding: 10px 20px;\n}\n\n.ride-details-top-container-date {\n  font-size: 14px;\n  font-weight: bold;\n}\n.ride-details-body {\n  padding: 10px 20px;\n}\n\n.ride-details-body-map {\n  width: 100%;\n  height: 150px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin: 10px 0;\n}\n\n.ride-details-body-map img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.ride-details-body-route {\n  margin: 10px 0;\n}\n\n.ride-details-body-waypoints {\n  margin: 10px 0;\n}\n\n.ride-details-body-description {\n  margin: 10px 0;\n  line-height: 1.4;\n}\n\n.ride-details-body-heading {\n  font-weight: bold;\n  color: #141414;\n  font-size: 15px !important;\n}\n\n.top-id {\n  font-size: 14px;\n  font-weight: 400;\n  color: #141414;\n}\n\n.top-id-bold {\n  font-weight: bold;\n  color: #ff4848;\n}\n\n.ride-details-body-description span {\n  font-size: 14px;\n  color: #363636;\n  font-weight: 400;\n}\n\n.ride-details-body-description p {\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  color: #363636;\n  font-weight: 400;\n}\n\n.ride-details-body h2 {\n  margin-bottom: 5px;\n}\n\n.Toastify__toast--success {\n  background: #2db931 !important;\n}\n\n.Toastify__toast {\n  border-radius: 0 !important;\n}\n\n.Toastify__toast-container--top-right {\n  bottom: 0 !important;\n}\n\n.feedback-main-container {\n  margin: auto;\n  text-align: center;\n  padding: 0 10px;\n}\n\n.feedback-main-container h2 {\n  font-weight: bold;\n  color: #363636;\n  font-size: 20px;\n  margin-bottom: 0;\n}\n\n.feedback-main-container textarea {\n  margin-top: 20px;\n}\n\n.feedback-header {\n  text-align: center !important;\n  width: 100%;\n  font-size: 24px;\n  font-weight: bold;\n  color: #363636;\n}\n\n.waypoints-col {\n  background-color: #ff4848;\n  color: #fff;\n  border-radius: 5px;\n  padding: 2px 20px;\n  margin-right: 10px;\n  margin-bottom: 5px;\n}\n\n.ride-details-mobile-top {\n  padding: 10px;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  display: none;\n  z-index: 99;\n}\n\n.ride-details-body-map-mobile {\n  display: none;\n  height: 220px;\n  width: 100%;\n}\n\n.leerfahrten-user-rides-container {\n  max-width: 600px;\n  margin: auto;\n}\n\n.leerfahrten-user-rides-container h1 {\n  font-weight: bold;\n  font-size: 30px;\n  margin: 10px 0;\n  color: #363636;\n  text-align: left;\n}\n\n.footer-btn {\n  border: none !important;\n  background-color: white !important;\n  background: white !important;\n  padding: 10px 0;\n}\n\n.footer-to-top {\n  margin-left: auto;\n  display: flex;\n}\n\n.leerfahrten-user-rides-container h2 {\n  font-weight: bold;\n  font-size: 20px;\n  margin: 20px 0 10px 0;\n  color: #363636;\n  text-align: left;\n}\n\n.ride-details-body-map-mobile img {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n}\n\n.ride-details-mobile-heading {\n  display: none !important;\n}\n\n.ride-details-mobile-contact-container {\n  display: none !important;\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  padding: 25px 0;\n  background-color: #fff;\n  z-index: 99;\n  box-shadow: 0px -2px 5px rgba(104, 39, 19, 0.2);\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n}\n\n.ride-details-mobile-contact-container .ride-details-profile-details-contact {\n  margin-top: 0;\n}\n\n.price-header {\n  font-weight: bold;\n  font-size: 18px;\n  color: #141414;\n}\n\n.payment-col {\n  width: 45px;\n  margin-right: 10px;\n  margin-top: 10px;\n}\n\n.mwst {\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.ride-details-footer {\n  display: block;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n  padding: 20px 0;\n  background-color: #fff;\n  z-index: 99;\n}\n\n.dashboard-ride-details-btn,\n.dashboard-ride-details-btn a {\n  color: white !important;\n  font-size: 14px;\n}\n\n.dashboard-ride-details-btn:hover {\n  background-color: #ff4848;\n  border-color: #ff4848;\n}\n\n.ride-details-footer-logo {\n  width: 120px !important;\n  cursor: pointer;\n}\n\n.ride-details-footer-logo svg {\n  height: 100%;\n}\n\n.ride-details-footer-links a {\n  margin-left: 10px;\n  font-weight: bold;\n  transition: all 0s;\n}\n\n.mobile-margin-container {\n  margin-bottom: 50px;\n}\n\n.ride-details-footer-links a:hover {\n  color: #ff4848;\n}\n\n/* CHAT */\n.chats-head {\n  border-bottom: 1px solid #ddd;\n  padding: 10px;\n}\n\n.chats-body {\n  overflow-y: scroll;\n  max-height: 200px;\n}\n\n.chats-inner-row {\n  border-bottom: 1px solid #ddd;\n  padding: 10px;\n}\n\n.chats-pic img {\n  height: 35px;\n}\n\n.chats-message {\n  margin-left: 10px;\n}\n\n.chats-message p {\n  margin: 0;\n}\n\n.chats-message-name {\n  font-weight: bold;\n  font-size: 12px;\n  color: #363636;\n}\n\n.chats-message-text {\n  font-size: 12px;\n  color: #363636;\n}\n\n.chats-info {\n  margin-left: auto;\n  margin-right: 5px;\n}\n\n.chats-info span {\n  font-size: 10px;\n  background-color: #47c653;\n  padding: 0 5px;\n  color: white;\n}\n\n.chats-icon img {\n  height: 13px;\n}\n\n.chats-icon span {\n  font-size: 12px;\n  font-weight: bold;\n  color: #363636;\n  display: block;\n}\n\n.dashboard-chats-container {\n  border: 1px solid #ddd;\n}\n\n.chat-side-container,\n.chat-main-container {\n  border: 1px solid #ddd;\n}\n\n.chat-main-container {\n  overflow-y: hidden;\n}\n\n.chat-side-top-bar,\n.chat-main-top-bar {\n  padding: 10px 10px;\n  border-bottom: 1px solid #ddd;\n  background-color: #fff;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  justify-content: space-between;\n}\n\n.chat-side-top-ntf {\n  background-color: #ff4848;\n  color: white;\n  padding: 2px 10px;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.chat-side-top-bar {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.chat-side-top-bar p {\n  margin: 0;\n  margin-left: 10px;\n  font-weight: bold;\n  color: #363636;\n}\n\n.chat-side-inner-container {\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n}\n\n.chat-side-inner-container:hover {\n  background-color: #f0f0f0;\n}\n\n.chat-side-pic {\n  position: relative;\n  margin-right: 10px;\n}\n\n.chat-side-pic img {\n  height: 35px;\n  width: 35px;\n  border-radius: 3px;\n  object-fit: cover;\n}\n\n.chat-side-text-name {\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0;\n  color: #363636;\n  display: block;\n}\n\n.chat-side-text-text {\n  color: #555;\n}\n\n.chat-side-text {\n  line-height: 1.2;\n  margin-right: 10px;\n}\n\n.chat-side-text-name p {\n  margin: 0;\n}\n\n.chat-side-ntf {\n  margin-left: auto;\n  line-height: 1.2;\n}\n\n.chat-side-ntf-days {\n  font-size: 14px;\n  display: block;\n  text-align: right;\n  margin-bottom: 5px;\n  color: #363636;\n}\n\n.chat-side-ntf-ntf {\n  padding: 0px 5px;\n  color: white;\n  background-color: #47c653;\n  font-size: 10px;\n  margin-right: 5px;\n}\n\n.chat-side-ntf-img {\n  height: 12px;\n}\n\n.chat-inner-wrapper {\n  height: 60vh;\n  overflow-y: scroll;\n}\n\n.chat-settings {\n  margin-left: 10px;\n  cursor: pointer;\n  height: 100%;\n  padding: 5px 0;\n}\n\n.chat-settings div {\n  border-radius: 50%;\n  height: 6px;\n  width: 6px;\n  background-color: #ddd;\n  margin: 0 1px;\n}\n\n.chat-main-profile-info {\n  background-color: #f0f0f0;\n  padding: 10px;\n  vertical-align: middle;\n  height: 55px;\n}\n\n.chat-main-info-profile-link img {\n  height: 14px;\n  margin-right: 5px;\n}\n\n.chat-main-inner-container {\n  height: calc(60vh - 55px);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-main-message-container {\n  bottom: 0;\n  width: 100%;\n  padding: 10px 20px;\n}\n\n.chat-message-bottom-send {\n  border: none;\n  margin-left: 5px;\n}\n\n.uploadPictures-container {\n  column-gap: 10px;\n  row-gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.uploadPictures-col {\n  width: 75px;\n  height: 75px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.uploadPictures-col img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.uploadPictures-add {\n  border: 1px dashed #ddd;\n  cursor: pointer;\n}\n\n.uploadPictures-add label {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  cursor: pointer;\n  line-height: 400%;\n}\n\n.chat-message-bottom-actions img {\n  height: 25px;\n}\n\n.chat-show-message-container {\n  padding: 10px 20px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  margin: 10px 0;\n}\n\n.chat-message {\n  margin-top: auto;\n  margin-bottom: 10px;\n}\n\n.chat-message:last-child {\n  margin-bottom: 0;\n}\n\n.chat-message-img img {\n  height: 35px;\n}\n\n.chat-message-text {\n  line-height: 1.2;\n}\n\n.chat-message-text p {\n  margin: 0;\n}\n\n.chat-message-name {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.chat-message-time {\n  margin-left: 5px;\n  font-size: 12px;\n}\n\n.chat-message-text {\n  display: block;\n}\n\n.chat-side-container a:hover {\n  text-decoration: none;\n}\n\n.offer-container {\n  border: 1px solid #ddd;\n  background-color: #fff;\n  color: #363636;\n  margin: 20px 20px;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.offer-container p {\n  margin: 0;\n  font-weight: bold;\n}\n\n.bottom-bar-default {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  padding: 20px;\n  background-color: #fff;\n  border-top: 1px solid #ddd;\n}\n\n.bottom-bar-default img {\n  height: 15px;\n}\n\n.rating-container {\n  height: 13px;\n  margin: 0;\n  padding: 0;\n  vertical-align: middle;\n}\n\n.rating-container img {\n  width: 100%;\n  height: 100%;\n  vertical-align: middle;\n}\n\n.home-text-section h2 {\n  color: #ff4848;\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 20px;\n}\n\n.home-text-section {\n  width: 65%;\n  margin: auto;\n  padding-bottom: 50px;\n}\n\n.home-text-section-container {\n  padding: 10px 0;\n}\n\n.home-text-section-container h3 {\n  font-weight: bold;\n  color: #363636;\n  font-size: 16px;\n  margin: 0;\n  margin-bottom: 5px;\n}\n\n.home-text-section-container span {\n  font-weight: 400;\n  color: #646464;\n  font-size: 16px;\n}\n\n.home-text-section-container-paragrap p {\n  font-weight: 400;\n  color: #646464;\n  font-size: 16px;\n  line-height: 1.5;\n}\n.ride-details-btn {\n  margin-left: 3rem;\n}\n\n.top-back-bar {\n  padding: 20px 0;\n  width: auto;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.chatInput {\n  padding: 5px !important;\n  font-size: 16px !important;\n  border-radius: 5px !important;\n  border-width: 1px !important;\n  border-color: #ddd !important;\n  margin-bottom: 10px !important;\n  width: 100% !important;\n}\n\n.chat-main-message-input textarea {\n  margin-bottom: 10px;\n}\n\n.payment-container {\n  max-width: 600px;\n  margin: auto;\n  padding: 20px 15px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 75px;\n}\n\n.payment-container h2 {\n  font-size: 24px;\n  font-weight: bold;\n  color: #363636;\n}\n\n.payment-main {\n  flex: 1;\n}\n\n.payment-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.payment-price-container {\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.payment-price-container span {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.payment-price-container p {\n  margin: 0;\n  padding: 0;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.payment-button button {\n  padding: 10px 40px;\n}\n\n.paymentMethod {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n\n.radio-out {\n  width: 25px;\n  height: 25px;\n  border-radius: 25px;\n  border: 1px solid #ddd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.radio-in {\n  width: 15px;\n  height: 15px;\n  border-radius: 25px;\n  background-color: #fff;\n}\n\n.paymentMethod img {\n  max-height: 24px;\n  margin-left: 10px;\n}\n\n.paymentMethod span {\n  margin-left: 10px;\n}\n\n.radio-active {\n  border: 1px solid #ff4848;\n}\n\n.radio-active .radio-in {\n  background-color: #ff4848;\n}\n\n@media screen and (max-width: 992px) {\n  .main-form-input-col .autocompleteInput {\n    border: 1px solid #ddd;\n    padding: 8px 10px;\n  }\n  .home-text-section {\n    width: 100%;\n  }\n  .result-content-container {\n    padding: 20px 15px;\n  }\n  .leerfahrten-main-background {\n    height: 350px;\n  }\n  .autocompleteContainer {\n    left: 0;\n    border: none;\n    margin-top: 20px;\n  }\n  .autocompleteItems {\n    padding: 10px 0;\n    font-size: 16px;\n  }\n  .noti-flex {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .details-isuser-container {\n    margin-top: 0;\n    padding-top: 60px !important;\n  }\n  .rating-cnt {\n    padding-top: 50px;\n  }\n  .rating-cnt h1 {\n    font-size: 30px;\n  }\n  .rating-cnt h3 {\n    font-size: 20px;\n  }\n  .desktop-hide {\n    display: block;\n  }\n  .price-modal {\n    position: fixed;\n    z-index: 9999999;\n    height: calc(100% - 70px);\n  }\n  .ride-details-btn {\n    margin-left: auto;\n  }\n  .ride-adress-date {\n    display: none;\n  }\n  /* CHAT */\n  .chat-phone .container {\n    width: 100%;\n    margin: auto;\n    max-width: 100%;\n  }\n  .phone-hide {\n    display: none !important;\n  }\n  .chat-phone .border-container {\n    border: none;\n    box-shadow: none;\n  }\n  .bottom-bar-default {\n    display: none;\n  }\n  .chat-main-top-bar {\n    position: fixed;\n    width: 100%;\n    z-index: 999;\n  }\n  .chat-main-profile-info {\n    position: fixed;\n    width: 100%;\n    margin-top: 62px;\n    z-index: 9999999;\n  }\n  .chat-phone {\n    padding-bottom: 0 !important;\n  }\n  .dashboard-container-privat {\n    display: block;\n  }\n  .dashboard-container-privat div {\n    margin-bottom: 5px;\n  }\n  .chat-phone .chat-side-container,\n  .chat-phone .chat-main-container {\n    border: none;\n  }\n  .chat-main-profile-info {\n    height: 65px;\n  }\n  .chat-main-message-container {\n    position: fixed;\n    background-color: #fff;\n    padding-bottom: 20px;\n  }\n  .chat-message {\n    margin: 5px 0;\n  }\n  .chat-main-inner-container {\n    height: auto;\n    padding-bottom: 100px;\n  }\n  .chat-show-message-container {\n    margin-top: 137px;\n  }\n  .chat-phone .chat-inner-wrapper {\n    height: auto;\n  }\n  .chat-phone .col-lg-4,\n  .chat-phone .col-lg-8 {\n    padding: 0;\n  }\n  .chat-phone .top-back-bar {\n    display: none;\n  }\n  .chat-phone .chat-side-top-bar,\n  .chat-main-top-bar {\n    padding: 20px;\n  }\n  .chat-phone .chat-side-pic img {\n    height: 45px;\n    width: 45px;\n  }\n\n  .navbar-toggle,\n  .leerfahrten-departure-sidebar {\n    display: block;\n  }\n  .listing-container {\n    padding-top: 0;\n  }\n  .ant-tabs-content-holder {\n    padding: 0 15px;\n  }\n  .listing-container .container {\n    padding: 0 !important;\n  }\n  .ant-tabs-nav {\n    border-top: 1px solid #ddd;\n    padding: 0px 15px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);\n  }\n  .mobile-margin-container {\n    margin-top: -70px;\n    margin-bottom: 120px;\n  }\n  .border-container {\n    background-color: #fff;\n  }\n  .ride-details-body-map,\n  .ride-details-footer {\n    display: none !important;\n  }\n  .ride-details-body-map-mobile,\n  .ride-details-mobile-contact-container {\n    display: block !important;\n  }\n  .ride-details-mobile-heading {\n    display: flex !important;\n  }\n  .app-ad-container {\n    height: 900px;\n  }\n  .app-add-img {\n    left: 10%;\n    width: 320px;\n    bottom: 0%;\n  }\n  .ride-details-profile-details-body,\n  .ride-details-top-container,\n  .ride-details-container .divider {\n    display: none !important;\n  }\n  .ride-details-container {\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0 10px;\n  }\n  .ride-details-body {\n    padding: 0;\n  }\n  .main-mobile-form-home {\n    display: block;\n  }\n  .ride-details-mobile-top {\n    display: block;\n  }\n  .main-desktop-form-home {\n    display: none;\n  }\n  .search-mobile-form-container {\n    display: flex !important;\n  }\n  #listing-search-container {\n    height: auto;\n    z-index: 3;\n  }\n  .listing-container .row {\n    margin: 0;\n  }\n  .result-container {\n    border: none;\n    padding: 0;\n  }\n  .map-container {\n    display: none;\n  }\n  .ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {\n    font-size: 14px;\n    padding: 10px;\n  }\n  .navbar-leerfahrten-brand {\n    width: 153px !important;\n    cursor: pointer;\n  }\n  .navbar-navigation,\n  .search-main-form {\n    display: none;\n  }\n\n  .navbar-navigation-mobile {\n    display: block;\n  }\n  .main-form-input-col {\n    padding: 5px 0;\n  }\n  #listing-search-container {\n    border-top: 1px solid #ccc !important;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .navbar-leerfahrten {\n    flex-wrap: nowrap;\n  }\n  .navbar-nav {\n    flex-direction: row;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .app-add-img {\n    left: 10%;\n    width: 280px;\n  }\n  .mobile-back-btn {\n    display: block;\n  }\n  .app-ad-container {\n    height: 900px;\n    overflow: hidden;\n  }\n  .settings-topbar-header {\n    text-align: center;\n  }\n\n  .help-container {\n    display: none;\n  }\n\n  .mobile-hide {\n    display: none;\n  }\n\n  .settings-container-mobile {\n    max-width: 100%;\n    width: 100%;\n    padding: 0;\n    margin-top: 0;\n  }\n\n  .settings-container-mobile .border-container {\n    border: none;\n    border-radius: 0;\n  }\n\n  .settings-container-mobile .setting-top-container {\n    border-radius: 0;\n  }\n\n  .settings-container-row {\n    padding: 15px;\n  }\n\n  .settings-container-row:hover {\n    background-color: #fff;\n  }\n\n  .settings-container-mobile .border-container {\n    margin-bottom: 0;\n    box-shadow: none;\n  }\n\n  .settings-container-mobile {\n    margin-bottom: 50px;\n  }\n\n  .setting-top-header {\n    text-align: center;\n  }\n\n  .setting-top-container {\n    box-shadow: 0px 2px 5px rgba(104, 39, 19, 0.2);\n    border-bottom: 2px solid #eee;\n  }\n  .forgot-password-cnt {\n    width: 100%;\n    border: none;\n    box-shadow: none;\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
